// debug-console.js - Shared Activity Log Logic
// Works with both swap-card and autoswap-card

// ============================================================
// STATE
// ============================================================

let debugLogStats = {
  total: 1,
  errors: 0,
  warnings: 0,
  success: 0,
  info: 1
};

// ============================================================
// UPDATE STATISTICS
// ============================================================

function updateDebugStats() {
  const totalEl = document.getElementById('debugStatTotal');
  const errorsEl = document.getElementById('debugStatErrors');
  const warningsEl = document.getElementById('debugStatWarnings');
  const successEl = document.getElementById('debugStatSuccess');
  
  if (totalEl) totalEl.textContent = debugLogStats.total;
  if (errorsEl) errorsEl.textContent = debugLogStats.errors;
  if (warningsEl) warningsEl.textContent = debugLogStats.warnings;
  if (successEl) successEl.textContent = debugLogStats.success;
}

// ============================================================
// LOG FUNCTION
// ============================================================

function debugLog(msg, type = 'info') {
  const display = document.getElementById("debugLogDisplay");
  if (!display) {
    console.log(`[Activity Log NOT READY] ${msg}`);
    return;
  }
  
  const t = new Date().toLocaleTimeString('en-US', { hour12: false });
  
  // Create log entry
  const entry = document.createElement('div');
  // silent-success renders green like success but does not affect counters
  const cssType = type === 'silent-success' ? 'success' : type;
  entry.className = `debug-log-entry ${cssType}`;
  entry.innerHTML = `
    <span class="debug-log-time">[${t}]</span>
    <span class="debug-log-message">${escapeHtml(msg)
      .replace(/\n/g, '<br>')
      .replace(/(https:\/\/solscan\.io\/tx\/[A-Za-z0-9]+)/g, '<a href="$1" target="_blank" style="color:#818cf8;">$1 →</a>')
    }</span>
  `;
  
  display.appendChild(entry);
  
  // Update statistics — silent-success is excluded intentionally (decorative only)
  if (type !== 'silent-success') {
    debugLogStats.total++;
    if (type === 'error') debugLogStats.errors++;
    if (type === 'warning') debugLogStats.warnings++;
    if (type === 'success') debugLogStats.success++;
    if (type === 'info') debugLogStats.info++;
    updateDebugStats();
  }
  
  // Auto-scroll to bottom
  display.scrollTop = display.scrollHeight;
  
  // Also log to browser console
  const prefix = `[${t}] [${type.toUpperCase()}]`;
  switch(type) {
    case 'error':
      console.error(prefix, msg);
      break;
    case 'warning':
      console.warn(prefix, msg);
      break;
    case 'success':
    case 'silent-success':
      console.log(`%c${prefix} ${msg}`, 'color: #10b981; font-weight: bold');
      break;
    default:
      console.log(prefix, msg);
  }
}

// ============================================================
// CLEAR LOG
// ============================================================

function clearDebugLog() {
  const display = document.getElementById("debugLogDisplay");
  if (!display) return;
  
  display.innerHTML = '<div class="debug-log-entry info"><span class="debug-log-time">[System]</span><span class="debug-log-message">Console cleared</span></div>';
  
  // Reset statistics
  debugLogStats = { total: 1, errors: 0, warnings: 0, success: 0, info: 1 };
  updateDebugStats();
}

// ============================================================
// EXPORT LOGS
// ============================================================

function exportDebugLogs() {
  const display = document.getElementById("debugLogDisplay");
  if (!display) {
    alert('Activity Log not found');
    return;
  }
  
  const entries = display.querySelectorAll('.debug-log-entry');
  
  let text = 'AquaVaults Activity Log Export\n';
  text += '================================\n';
  text += `Exported: ${new Date().toLocaleString()}\n`;
  text += `Page: ${document.title}\n`;
  text += '\n';
  
  entries.forEach(entry => {
    const time = entry.querySelector('.debug-log-time')?.textContent || '[??:??:??]';
    const message = entry.querySelector('.debug-log-message')?.textContent || '';
    const type = entry.className.replace('debug-log-entry ', '').trim();
    text += `${time} [${type.toUpperCase()}] ${message}\n`;
  });
  
  text += `\n================================\n`;
  text += `Statistics:\n`;
  text += `  Total Logs: ${debugLogStats.total}\n`;
  text += `  Errors: ${debugLogStats.errors}\n`;
  text += `  Warnings: ${debugLogStats.warnings}\n`;
  text += `  Success: ${debugLogStats.success}\n`;
  text += `  Info: ${debugLogStats.info}\n`;
  
  // Create download
  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `aquavaults-debug-${Date.now()}.txt`;
  a.click();
  URL.revokeObjectURL(url);
  
  debugLog('Debug logs exported successfully', 'success');
}

// ============================================================
// UTILITY FUNCTIONS
// ============================================================

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// ============================================================
// INITIALIZATION
// ============================================================

function initDebugConsole() {
  
  // Set status indicator
  const statusEl = document.getElementById('debugStatusIndicator');
  if (statusEl) {
    statusEl.textContent = 'Active';
    statusEl.style.color = '#10b981';
  }
}

// ============================================================
// EXPORTS (Global Window)
// ============================================================

window.debugLog = debugLog;
window.clearDebugLog = clearDebugLog;
window.exportDebugLogs = exportDebugLogs;

// ============================================================
// AUTO-INITIALIZE
// ============================================================

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDebugConsole);
} else {
  // DOM already loaded
  initDebugConsole();
}

;
// swapper.js - Core swap functionality for AquaVaults
// This file handles wallet connection, token swaps, and Jupiter API integration

// ============================================================
// LOGGING WRAPPER
// ============================================================

function log(...args) {
  const LEVELS = new Set(['info', 'success', 'silent-success', 'warning', 'error', 'pending']);

  let type = 'info';
  if (args.length > 1 && typeof args[args.length - 1] === 'string' && LEVELS.has(args[args.length - 1])) {
    type = args.pop();
  }

  const msg = args
    .map(v => {
      if (typeof v === 'string') return v;
      try { return JSON.stringify(v); } catch { return String(v); }
    })
    .join(' ');

  if (window.debugLog) window.debugLog(msg, type);
  else console.log(msg);
}

// ============================================================
// CONFIGURATION
// ============================================================

const JUPITER_API_BASE = "/api/jupiter";

function uiAmountToBaseUnits(amountStr, decimals) {
  const s = String(amountStr).trim();
  if (!/^\d+(\.\d+)?$/.test(s)) throw new Error(`Invalid amount: "${amountStr}"`);

  const [whole, frac = ""] = s.split(".");
  const fracPadded = (frac + "0".repeat(decimals)).slice(0, decimals);
  const combined = (whole.replace(/^0+(?=\d)/, "") || "0") + fracPadded;

  const normalized = combined.replace(/^0+(?=\d)/, "") || "0";
  return BigInt(normalized);
}

// Token mint addresses
const TOKEN_MINTS = {
  "SOL": "So11111111111111111111111111111111111111112",
  "USDC": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  "USDT": "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
  "wPOND": "3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq",
  "hSOL": "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A",
  "mSOL": "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
  "PepeOnSOL": "B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B"
};

// Reverse mapping: mint address -> symbol (for logs and error messages)
const MINT_TO_SYMBOL = Object.fromEntries(
  Object.entries(TOKEN_MINTS).map(([sym, mint]) => [mint, sym])
);

// Accept either a preset symbol (e.g. "SOL") OR a mint address (custom tokens)
function resolveMint(symbolOrMint) {
  if (!symbolOrMint) return null;
  if (TOKEN_MINTS[symbolOrMint]) return TOKEN_MINTS[symbolOrMint]; // preset symbol
  // Heuristic: mint-like strings are usually 32+ chars base58
  if (typeof symbolOrMint === 'string' && symbolOrMint.length >= 32) return symbolOrMint;
  return null;
}

const TOKEN_DECIMALS = {
  "So11111111111111111111111111111111111111112": 9,  // SOL
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v": 6,  // USDC
  "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB": 6,  // USDT
  "3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq": 3,  // wPOND
  "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A": 9,   // hSOL
  "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So": 9,   // mSOL
  "B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B": 6,  // PepeOnSOL
};

// Pond0x Token Vaults (Affiliate A)
const TOKEN_VAULTS_AFFILIATE_1 = {
  "So11111111111111111111111111111111111111112": "9hCLuXrQrHCU9i7y648Nh7uuWKHUsKDiZ5zyBHdZPWtG",
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v": "6NqvoPpSYCPEtLEukQaSNs7mS3yK6k285saH9o3vgC96",
  "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB": "5LmFGjbae5iWejFVT8UiRLggh1me22nTetmere8SjwKy",
  "3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq": "GKHmDYWPE8Bf74xDntnpx4hi4H7pRp3HK5QYvPyXGEiU",
  "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A": "4jkVjzXtrCuxQus3neMtLfNL4wZhsPmm9fKGXoLMXqsG",
  "B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B": "3qGSU2RySrjvQ2iGMts2HZ4ssGVSrBUSGL4jN7LHGhgo",
};

// AquaVaults Token Vaults (Affiliate B)
const TOKEN_VAULTS_AFFILIATE_2 = {
  "So11111111111111111111111111111111111111112": "2qcR7nCVRmpxHCYTdQ6G1DjNcDzgEq9eQ1ZrxcmjeVy9",
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v": "4en3gmtiPtmiHCi5mwT1TrATj4jNe7woJPZLQaWv6Ezu",
  "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB": "5wV1qSp8n9z5DEGHV6JJoEoxdYeBrnVCtP9LbD4Vwx7D",
  "3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq": "E4s4KzRBvYQxpFR1L7z7cLDtT814i7bqWFSGgqCDBCn9",
  "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A": "54GcC3SjZzavvVJ5ipFfCvQHNnpPRsJLXUdfxNmeJHHm",
  "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So": "49URcyxPiaKRgoEAWfDtJHGWcZus3SVkF39b9Szf3XqC",
  "B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B": "Ff7tzrabm8sxHbL4cTmBDby2EQvvtab6NTh56R69u6KS",
};

const AFFILIATE_B_SOL_WALLET = "HuBtMA1VKjcd64LfovZj6vtbZitkKNRBwbAkY8oQre2c";
const TOKEN_PROGRAM_ID = new solanaWeb3.PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const TOKEN_2022_PROGRAM_ID = new solanaWeb3.PublicKey("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
const ASSOCIATED_TOKEN_PROGRAM_ID = new solanaWeb3.PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
const SYSTEM_PROGRAM_ID = solanaWeb3.SystemProgram.programId;
const RENT_SYSVAR_ID = new solanaWeb3.PublicKey("SysvarRent111111111111111111111111111111111");

function getTokenProgramIdForMint(mint) {
  try {
    if (window.TokenRegistry && typeof window.TokenRegistry.getTokenProgram === 'function') {
      const v = window.TokenRegistry.getTokenProgram(mint);
      
      // Common label returns
      if (v === 'token-2022' || v === 'Token-2022' || v === 'TOKEN_2022') return TOKEN_2022_PROGRAM_ID;
      if (v === 'token' || v === 'spl-token' || v === 'TOKEN') return TOKEN_PROGRAM_ID;
      
      // If it ever returns a real address
      if (typeof v === 'string' && v.length >= 32) return new solanaWeb3.PublicKey(v);
    }
  } catch (_) {}
  return TOKEN_PROGRAM_ID;
}

function getAssociatedTokenAddress(mint, owner, tokenProgramId = TOKEN_PROGRAM_ID) {
  const mintPk = (mint instanceof solanaWeb3.PublicKey) ? mint : new solanaWeb3.PublicKey(mint);
  const ownerPk = (owner instanceof solanaWeb3.PublicKey) ? owner : new solanaWeb3.PublicKey(owner);

  // ATA PDA seeds: [owner, tokenProgramId, mint]
  const [ata] = solanaWeb3.PublicKey.findProgramAddressSync(
    [ownerPk.toBuffer(), tokenProgramId.toBuffer(), mintPk.toBuffer()],
    ASSOCIATED_TOKEN_PROGRAM_ID
  );

  return ata.toBase58();
}

function createAssociatedTokenAccountIx({ payer, owner, mint, tokenProgramId = TOKEN_PROGRAM_ID }) {
  const ata = getAssociatedTokenAddress(mint, owner, tokenProgramId);

  return {
    ata,
    ix: new solanaWeb3.TransactionInstruction({
      programId: ASSOCIATED_TOKEN_PROGRAM_ID,
      keys: [
        { pubkey: new solanaWeb3.PublicKey(payer), isSigner: true, isWritable: true },
        { pubkey: new solanaWeb3.PublicKey(ata), isSigner: false, isWritable: true },
        { pubkey: new solanaWeb3.PublicKey(owner), isSigner: false, isWritable: false },
        { pubkey: new solanaWeb3.PublicKey(mint), isSigner: false, isWritable: false },
        { pubkey: SYSTEM_PROGRAM_ID, isSigner: false, isWritable: false },
        { pubkey: tokenProgramId, isSigner: false, isWritable: false },
        { pubkey: RENT_SYSVAR_ID, isSigner: false, isWritable: false },
      ],
      data: new Uint8Array([]),
    }),
  };
}

function createSplTransferIx({ source, destination, owner, amount, tokenProgramId = TOKEN_PROGRAM_ID }) {
  const data = new Uint8Array(1 + 8);
  data[0] = 3;

  let a = BigInt(amount);
  for (let i = 0; i < 8; i++) {
    data[1 + i] = Number(a & 0xffn);
    a >>= 8n;
  }

  return new solanaWeb3.TransactionInstruction({
    programId: tokenProgramId,
    keys: [
      { pubkey: new solanaWeb3.PublicKey(source), isSigner: false, isWritable: true },
      { pubkey: new solanaWeb3.PublicKey(destination), isSigner: false, isWritable: true },
      { pubkey: new solanaWeb3.PublicKey(owner), isSigner: true, isWritable: false },
    ],
    data,
  });
}

// Token-2022 variant: uses TransferChecked (opcode 12) which includes mint + decimals.
// Required by any Token-2022 mint — plain Transfer (opcode 3) will fail with 0x1f.
function createSplTransferCheckedIx({ source, mint, destination, owner, amount, decimals, tokenProgramId = TOKEN_PROGRAM_ID }) {
  // TransferChecked data layout: [opcode(1)] [amount u64 LE(8)] [decimals u8(1)] = 10 bytes
  const data = new Uint8Array(10);
  data[0] = 12; // TransferChecked opcode

  let a = BigInt(amount);
  for (let i = 0; i < 8; i++) {
    data[1 + i] = Number(a & 0xffn);
    a >>= 8n;
  }
  data[9] = decimals;

  return new solanaWeb3.TransactionInstruction({
    programId: tokenProgramId,
    keys: [
      { pubkey: new solanaWeb3.PublicKey(source), isSigner: false, isWritable: true },
      { pubkey: new solanaWeb3.PublicKey(mint),   isSigner: false, isWritable: false },
      { pubkey: new solanaWeb3.PublicKey(destination), isSigner: false, isWritable: true },
      { pubkey: new solanaWeb3.PublicKey(owner), isSigner: true, isWritable: false },
    ],
    data,
  });
}

// Convert Jupiter instruction format to Solana TransactionInstruction
function jupiterInstructionToSolana(jupIx) {
  return new solanaWeb3.TransactionInstruction({
    programId: new solanaWeb3.PublicKey(jupIx.programId),
    keys: jupIx.accounts.map(acc => ({
      pubkey: new solanaWeb3.PublicKey(acc.pubkey),
      isSigner: acc.isSigner,
      isWritable: acc.isWritable,
    })),
    data: Buffer.from(jupIx.data, 'base64'),
  });
}

// ============================================================
// STATE
// ============================================================

let connection = null;
let walletPublicKey = null;
let isWalletConnected = false;
// Community selection is now dynamic via localStorage + CommunityRegistry
function getSelectedCommunity() {
  const communityId = localStorage.getItem('selectedCommunity') || 'aquavaults';
  if (!window.CommunityRegistry) return null;
  return window.CommunityRegistry.get(communityId) || window.CommunityRegistry.get('aquavaults');
}

// ============================================================
// UTILITY FUNCTIONS
// ============================================================

function base64ToUint8Array(base64) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

function splitBps60_40(totalBps) {
  const feeA = Math.floor(totalBps * 60 / 100);
  const feeB = totalBps - feeA;
  return { feeA, feeB };
}

// ============================================================
// CONFIRMED FEE STRATEGY (matches working index.html exactly)
// ============================================================
// Three possible strategies:
// 1. SPLIT_60_40: Pond0x selected AND vault exists - 60% to Pond0x, 40% to AquaVaults
// 2. FALLBACK_100_AQUAVAULTS: Pond0x selected BUT no vault - 100% to AquaVaults
// 3. AQUAVAULTS_100: AquaVaults selected - 100% to AquaVaults
// ============================================================
function computeFeePlan(inputMint, totalSpend, platformFeeBps) {
  // Defense-in-depth: never trust UI/localStorage values
  if (!Number.isFinite(platformFeeBps)) throw new Error("Invalid platform fee");
  platformFeeBps = Math.max(0, Math.min(1000, Math.floor(platformFeeBps)));

  const isSolInput = (inputMint === TOKEN_MINTS.SOL);
  
  // Get selected community from localStorage + registry, default to AquaVaults
  let communityId = localStorage.getItem('selectedCommunity') || 'aquavaults';
  let community = window.CommunityRegistry.get(communityId);

  if (!community) {
    communityId = 'aquavaults';
    localStorage.setItem('selectedCommunity', communityId);
    community = window.CommunityRegistry.get(communityId);
  }
  
  if (!community) {
    throw new Error(`Community '${communityId}' not found in registry`);
  }
  
  // Check if community has a vault for this token
  const communityHasVault = window.CommunityRegistry.hasTokenVault(communityId, inputMint);
  const communityVault = window.CommunityRegistry.getTokenVault(communityId, inputMint);
  const communityBackupWallet = window.CommunityRegistry.getBackupWallet(communityId);
  const aquaVaultsBackup = window.CommunityRegistry.getBackupWallet('aquavaults');
  
  let feeStrategy;
  let platformFeeBpsForJupiter = 0;
  let amountForQuote;
  let jupiterFeeAccount = null;
  let transferPlan = null;

  if (platformFeeBps === 0) {
    feeStrategy = "NO_FEES";
    amountForQuote = totalSpend;
  } else if (communityId === 'aquavaults') {
    feeStrategy = "AQUAVAULTS_100";
    platformFeeBpsForJupiter = platformFeeBps;
    amountForQuote = totalSpend;
    jupiterFeeAccount = TOKEN_VAULTS_AFFILIATE_2[inputMint] || null;
  } else {
    const split = splitBps60_40(platformFeeBps);
    const feeA_bps = communityHasVault ? split.feeA : split.feeB;
    const feeB_bps = communityHasVault ? split.feeB : split.feeA;
    const feeB_amount = (totalSpend * BigInt(feeB_bps)) / 10000n;
    
    if (communityHasVault) {
      feeStrategy = "SPLIT_60_COMMUNITY_40_AV";
      platformFeeBpsForJupiter = feeA_bps;
      jupiterFeeAccount = communityVault;  // Community vault (token account)
      
      transferPlan = {
        mint: inputMint,
        amount: feeB_amount.toString(),
        destinationOwner: aquaVaultsBackup,  // AquaVaults backup wallet
        destinationType: "wallet",
      };
    } else {
      feeStrategy = "SPLIT_40_AV_60_COMMUNITY";
      platformFeeBpsForJupiter = feeA_bps;
      jupiterFeeAccount = TOKEN_VAULTS_AFFILIATE_2[inputMint] || null;  // AquaVaults vault (will trigger worker if null)
      
      transferPlan = {
        mint: inputMint,
        amount: feeB_amount.toString(),
        destinationOwner: communityBackupWallet,  // Community backup wallet (NEVER a vault!)
        destinationType: "wallet",
      };
    }
    
    amountForQuote = totalSpend - feeB_amount;
  }
  
  // Ensure vault exists if routing fees through Jupiter
  if (platformFeeBpsForJupiter > 0 && !jupiterFeeAccount) {
    // For custom tokens without vaults, we need to create one via worker
    // This happens synchronously in computeFeePlan, but the actual vault creation
    // will be handled in executeSwap before calling Jupiter
    jupiterFeeAccount = "NEEDS_WORKER_CREATION";
  }
  
  return {
    feeStrategy,
    platformFeeBpsForJupiter,
    amountForQuote,
    jupiterFeeAccount,
    transferPlan,
    feeMint: inputMint,
  };
}

// Cache to reduce RPC calls
const decimalsCache = {};

async function getTokenDecimals(mintAddress) {
  // 1) Hardcoded first (most reliable)
  if (TOKEN_DECIMALS[mintAddress] !== undefined) return TOKEN_DECIMALS[mintAddress];

  // 2) TokenRegistry next (covers custom tokens added via picker)
  try {
    if (window.TokenRegistry && typeof window.TokenRegistry.getDecimals === 'function') {
      const d = window.TokenRegistry.getDecimals(mintAddress);
      if (typeof d === 'number') {
        decimalsCache[mintAddress] = d;
        return d;
      }
    }
  } catch (_) {
    // ignore registry miss; fall through
  }

  // 3) Cached next
  if (decimalsCache[mintAddress] !== undefined) return decimalsCache[mintAddress];

  // 4) Must have connection to fetch
  if (!connection) {
    throw new Error(`Not connected to RPC - cannot fetch decimals for ${mintAddress}`);
  }

  try {
    const mintPubkey = new solanaWeb3.PublicKey(mintAddress);
    const mintInfo = await connection.getParsedAccountInfo(mintPubkey);
    const decimals = mintInfo?.value?.data?.parsed?.info?.decimals;

    if (typeof decimals === 'number') {
      decimalsCache[mintAddress] = decimals;
      return decimals;
    }
  } catch (err) {
    log(`Error fetching decimals for ${mintAddress}: ${err?.message || err}`, 'error');
  }

  // CRITICAL: Do NOT fall back to 6. Wrong decimals = wrong swap amounts = lost funds.
  throw new Error(
    `Could not determine decimals for token: ${mintAddress}\n` +
    `Decimals are required for accurate swap math. Please try again.`
  );
}

async function getUserTokenAccountForMint(ownerPubkeyStr, mintStr, tokenProgramId = TOKEN_PROGRAM_ID) {
  if (mintStr === "So11111111111111111111111111111111111111112") {
    return null;
  }

  const owner = new solanaWeb3.PublicKey(ownerPubkeyStr);

  // Tokenkeg: fastest path (direct mint filter)
  if (tokenProgramId.equals(TOKEN_PROGRAM_ID)) {
    const res = await connection.getParsedTokenAccountsByOwner(
      owner,
      { mint: new solanaWeb3.PublicKey(mintStr) }
    );
    if (!res.value.length) return null;
    return res.value[0].pubkey.toBase58();
  }

  // Token-2022: must query by programId, then filter by mint
  const res = await connection.getParsedTokenAccountsByOwner(
    owner,
    { programId: tokenProgramId }
  );

  if (!res.value.length) return null;

  const match = res.value.find(v => {
    const mint = v?.account?.data?.parsed?.info?.mint;
    return mint === mintStr;
  });

  return match ? match.pubkey.toBase58() : null;
}

function createSolTransferIx({ fromPubkey, toPubkey, lamports }) {
  return solanaWeb3.SystemProgram.transfer({
    fromPubkey: new solanaWeb3.PublicKey(fromPubkey),
    toPubkey: new solanaWeb3.PublicKey(toPubkey),
    lamports: lamports,
  });
}

// ============================================================
// RPC CONNECTION INITIALIZATION
// ============================================================

async function initializeConnection() {
  try {
    connection = new solanaWeb3.Connection(window.location.origin + '/api/rpc', 'processed');
    await connection.getLatestBlockhash();
    return true;
  } catch (err) {
    log('❌ RPC connection failed:', err.message);
    return false;
  }
}

// ============================================================
// WALLET FUNCTIONS
// ============================================================

async function connectWallet() {
  // Use the unified wallet from Jupiter kit
  if (!window.AquaVaultsWallet) {
    alert("⚠️ Wallet widget not loaded. Please refresh the page.");
    return false;
  }
  
  if (isWalletConnected) {
    return disconnectWallet();
  }

  try {
    // The widget handles connection UI, we just need to check state
    if (window.AquaVaultsWallet.connected && window.AquaVaultsWallet.publicKeyString) {
      walletPublicKey = window.AquaVaultsWallet.publicKeyString;
      isWalletConnected = true;
      return true;
    } else {
      // Trigger connection via the widget
      await window.AquaVaultsWallet.connect();
      
      // Wait briefly for connection to complete
      await new Promise(resolve => setTimeout(resolve, 500));
      
      if (window.AquaVaultsWallet.connected && window.AquaVaultsWallet.publicKeyString) {
        walletPublicKey = window.AquaVaultsWallet.publicKeyString;
        isWalletConnected = true;
        return true;
      }
      
      throw new Error('Connection failed or was cancelled');
    }
  } catch (err) {
    log('❌ Wallet connection failed:', err.message);
    throw new Error(err.message || 'Unexpected error');
  }
}

async function disconnectWallet() {
  if (window.AquaVaultsWallet?.connected) {
    await window.AquaVaultsWallet.disconnect();
  }
  
  walletPublicKey = null;
  isWalletConnected = false;
  
  log('Wallet disconnected');
  return false;
}

// ============================================================
// BALANCE FUNCTIONS
// ============================================================

async function getBalance(tokenSymbol) {
  if (!walletPublicKey || !connection) return 0;
  
  const mint = resolveMint(tokenSymbol);
  let bal = 0;
  
  try {
    if (mint === "So11111111111111111111111111111111111111112") {
      bal = (await connection.getBalance(new solanaWeb3.PublicKey(walletPublicKey))) / 1e9;
    } else {
      const accs = await connection.getParsedTokenAccountsByOwner(
        new solanaWeb3.PublicKey(walletPublicKey),
        { mint: new solanaWeb3.PublicKey(mint) }
      );
      if (accs.value.length > 0) {
        bal = accs.value[0].account.data.parsed.info.tokenAmount.uiAmount;
      }
    }
  } catch (err) {
    log('Error fetching balance:', err);
  }
  
  return bal;
}

// ============================================================
// QUOTE/ESTIMATE FUNCTIONS
// ============================================================

// Store last UI quote context for Option C price protection
let lastUiQuoteContext = null;

async function getSwapQuote(fromSymbol, toSymbol, amount, slippageBps, platformFeeBps) {
  
  if (!connection) {
    log('Quote skipped: no RPC connection', 'warning');
    return null;
  }
  
  const inputMint = resolveMint(fromSymbol);
  const outputMint = resolveMint(toSymbol);
  
  if (!inputMint || !outputMint || !amount || amount <= 0) {
    log(`Quote skipped: invalid params from=${fromSymbol} to=${toSymbol} amount=${amount}`, 'warning');
    return null;
  }
  
  try {
    const inDecimals = await getTokenDecimals(inputMint);
    const totalSpend = uiAmountToBaseUnits(amount, inDecimals);
    if (totalSpend <= 0n) return null;
    
    // Use the SAME fee math as execution (CONFIRMED strategy from index.html)
    const feePlan = computeFeePlan(inputMint, totalSpend, platformFeeBps);
    
    if (feePlan.amountForQuote <= 0n) return null;
    
    // Quote with the EXACT same parameters that execution will use
    // instructionVersion=V2 is required: platformFeeBps > 255 fails under V1
    const url = `${JUPITER_API_BASE}/swap/v1/quote?inputMint=${inputMint}&outputMint=${outputMint}&amount=${feePlan.amountForQuote}&slippageBps=${slippageBps}&platformFeeBps=${feePlan.platformFeeBpsForJupiter}&instructionVersion=V2`;
    
    const quoteRes = await fetch(url);
    if (!quoteRes.ok) {
      const errText = await quoteRes.text();
      log(`Quote HTTP error (${quoteRes.status}): ${errText}`, 'error');
      return null;
    }
    const quote = await quoteRes.json();
    
    if (quote.error) {
      log(`Quote error: ${quote.error}`, 'error');
      return null;
    }
    
    const outDecimals = await getTokenDecimals(outputMint);
    const estimatedOutput = Number(quote.outAmount) / 10 ** outDecimals;

    // Store context for Option C protection (compare on swap click)
    lastUiQuoteContext = {
      inputMint,
      outputMint,
      amountForQuote: feePlan.amountForQuote,
      slippageBps,
      platformFeeBpsForJupiter: feePlan.platformFeeBpsForJupiter,

      // Jupiter returns outAmount as a string integer in base units
      outAmount: quote.outAmount, // keep for backwards compat
      outAmountStr: String(quote.outAmount),
      outAmountBI: BigInt(String(quote.outAmount)),

      fetchedAt: Date.now(),
      outDecimals,
    };


    
    return {
      quote,
      estimatedOutput,
      inputMint,
      outputMint,
      feeBreakdown: {
        totalInputAmount: amount,
        platformFeeAmount: feePlan.transferPlan ? Number(feePlan.transferPlan.amount) / 10 ** inDecimals : 0,
        swapAmount: Number(feePlan.amountForQuote) / 10 ** inDecimals,
        platformFeeBpsForJupiter: feePlan.platformFeeBpsForJupiter,
        feeStrategy: feePlan.feeStrategy,
      },
    };
  } catch (err) {
    log(`Error getting quote: ${err?.message || err}`, 'error');
    return null;
  }
}

// ============================================================
// VOLUME TRACKING HELPERS
// ============================================================

const SOL_MINT_FOR_VOLUME = 'So11111111111111111111111111111111111111112';

/**
 * Compute SOL-equivalent lamports for a swap.
 * - SOL input → inAmount is already lamports
 * - SOL output → outAmount is the SOL equivalent (no extra quote needed)
 * - Other → fetch a Jupiter quote inputMint→SOL
 */
async function getSolEquivLamports(inputMint, inAmountStr, outputMint, outAmountStr, slippageBps) {
  if (!inputMint || !inAmountStr) return null;

  // Case 1: input IS SOL — inAmount is already lamports
  if (inputMint === SOL_MINT_FOR_VOLUME) return inAmountStr;

  // Case 2: output IS SOL — outAmount is the SOL equivalent (free, no extra quote)
  if (outputMint === SOL_MINT_FOR_VOLUME && outAmountStr) return outAmountStr;

  // Case 3: neither side is SOL — need a price quote
  try {
    const url = `${JUPITER_API_BASE}/swap/v1/quote?inputMint=${encodeURIComponent(inputMint)}&outputMint=${encodeURIComponent(SOL_MINT_FOR_VOLUME)}&amount=${encodeURIComponent(inAmountStr)}&slippageBps=${encodeURIComponent(String(slippageBps || 50))}`;
    const res = await fetch(url, { method: 'GET', headers: { 'x-av-cache-bust': '1' } });
    if (!res.ok) return null;
    const q = await res.json().catch(() => ({}));
    return q?.outAmount || null;
  } catch (_) {
    return null;
  }
}

async function commitExecutedVolume({ signature, kind, communityId, inputMint, inAmount, solEquivLamports }) {
  try {
    await fetch('/api/volume/commit', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ signature, kind, communityId, inputMint, inAmount, solEquivLamports }),
    });
  } catch (_) {
    // Non-blocking: volume tracking failure must never break swap UX
  }
}

// ============================================================
// SWAP EXECUTION
// ============================================================

async function executeSwap(fromSymbol, toSymbol, amount, slippageBps, platformFeeBps, priorityFeeLamports = 0) {
  try {
    if (!connection) throw new Error("Not connected to network");
    if (!walletPublicKey) throw new Error("Wallet not connected");
  
  const inputMint = resolveMint(fromSymbol);
  const outputMint = resolveMint(toSymbol);
  if (!inputMint || !outputMint) throw new Error("Invalid token selection");
  
  // ============================================================
  // BALANCE SAFETY CHECKS
  // ============================================================
  const userBal = await getBalance(fromSymbol);
  
  if (inputMint === TOKEN_MINTS.SOL) {
    // SOL needs extra for fees/rent + (in split mode) feeB transfer
    const buffer = 0.005; // cushion for tx fees + possible ATA rent
    if (userBal < amount + buffer) {
      throw new Error(
        `Insufficient SOL balance.\n\n` +
        `Required: ${(amount + buffer).toFixed(6)} SOL\n` +
        `Available: ${userBal.toFixed(6)} SOL\n\n` +
        `You need extra SOL for network fees.`
      );
    }
  } else {
    if (userBal < amount) {
      const fromLabel = (window.TokenRegistry && window.TokenRegistry.getSymbol)
        ? window.TokenRegistry.getSymbol(inputMint)
        : (MINT_TO_SYMBOL[inputMint] || fromSymbol);

      throw new Error(
        `Insufficient ${fromLabel} balance.\n\n` +
        `Required: ${amount.toFixed(6)} ${fromLabel}\n` +
        `Available: ${userBal.toFixed(6)} ${fromLabel}`
      );
    }
    // Also ensure user has SOL for tx fees
    const solBal = await getBalance('SOL');
    if (solBal < 0.003) {
      throw new Error(
        `Insufficient SOL for network fees.\n\n` +
        `Need at least ~0.003 SOL available.\n` +
        `Available: ${solBal.toFixed(6)} SOL`
      );
    }
  }
  
  const fromLabel = (window.TokenRegistry && window.TokenRegistry.getSymbol)
    ? window.TokenRegistry.getSymbol(inputMint)
    : (MINT_TO_SYMBOL[inputMint] || fromSymbol);
  log(`Balance check passed: ${userBal.toFixed(6)} ${fromLabel} available`, 'info');
  
  // ============================================================
  // COMPUTE FEE PLAN (matches index.html exactly)
  // ============================================================
  const inDecimals = await getTokenDecimals(inputMint);
  const totalSpend = uiAmountToBaseUnits(amount, inDecimals);
  if (totalSpend <= 0n) throw new Error("Invalid amount");
  
  const feePlan = computeFeePlan(inputMint, totalSpend, platformFeeBps);
  
  if (feePlan.amountForQuote <= 0) throw new Error("Fee is too high for this amount");

  // Vault validation now handled by feePlan
  
  // Skip per-swap settings log during auto swap cycles — logConfigurationPreview already logged them once at start.
  if (!window._autoswapActive) {
    log('=== SWAP SETTINGS ===', 'info');
    log(`Strategy: ${feePlan.feeStrategy}`, 'info');
    log(`Slippage: ${(slippageBps / 100).toFixed(2)}%`, 'info');
    log(`Platform Fee: ${(platformFeeBps / 100).toFixed(2)}%`, 'info');
    log(`Priority Fee: ${priorityFeeLamports === 0 ? 'Auto' : priorityFeeLamports + ' lamports'}`, 'info');
    const community = getSelectedCommunity();
    log(`Community: ${community ? community.name : 'None'}`, 'info');
  }
  
  // ============================================================
  // FETCH FRESH QUOTE FOR EXECUTION
  // instructionVersion=V2 is required: platformFeeBps > 255 fails under V1
  // ============================================================
  const quoteUrl = `${JUPITER_API_BASE}/swap/v1/quote?inputMint=${inputMint}&outputMint=${outputMint}&amount=${feePlan.amountForQuote}&slippageBps=${slippageBps}&platformFeeBps=${feePlan.platformFeeBpsForJupiter}&instructionVersion=V2`;

  const quoteRes = await fetch(quoteUrl, {
      method: 'GET',
      headers: { 'x-av-cache-bust': '1' },
    });
  if (!quoteRes.ok) {
    const errText = await quoteRes.text();
    throw new Error(`Quote HTTP error (${quoteRes.status}): ${errText}`);
  }
  const quote = await quoteRes.json();
  const quoteFetchedAt = Date.now(); // Mark when quote is actually obtained

  if (quote.error) {
    throw new Error(`Quote error: ${quote.error}`);
  }
  
  // ============================================================
  // OPTION C: AUTOMATIC PRICE PROTECTION
  // Compare fresh quote vs what user saw in UI
  // ============================================================
  const outDecimals = await getTokenDecimals(outputMint);

  const freshOutStr = String(quote.outAmount);                 // Jupiter returns string
  const freshOutBI  = BigInt(freshOutStr);                     // base units as BigInt
  const freshOutUi  = Number(freshOutStr) / 10 ** outDecimals; // display only

  if (
    lastUiQuoteContext &&
    lastUiQuoteContext.inputMint === inputMint &&
    lastUiQuoteContext.outputMint === outputMint &&
    lastUiQuoteContext.amountForQuote === feePlan.amountForQuote &&
    lastUiQuoteContext.slippageBps === slippageBps &&
    lastUiQuoteContext.platformFeeBpsForJupiter === feePlan.platformFeeBpsForJupiter
  ) {
    const oldOutBI = (typeof lastUiQuoteContext.outAmountBI === 'bigint')
      ? lastUiQuoteContext.outAmountBI
      : BigInt(String(lastUiQuoteContext.outAmount)); // fallback for old context

    if (oldOutBI > 0n) {
      const diff = (freshOutBI >= oldOutBI) ? (freshOutBI - oldOutBI) : (oldOutBI - freshOutBI);
      const changeBps = (diff * 10_000n) / oldOutBI;  // integer bps, no floats

      if (changeBps > 200n) { // 200 bps = 2.0%
        const oldOutUi = Number(oldOutBI.toString()) / 10 ** lastUiQuoteContext.outDecimals;
        const pctChange = Number(changeBps) / 100;
        const sym = MINT_TO_SYMBOL[outputMint] || toSymbol;

        throw new Error(
          `⚠️ Price moved while you were reviewing.\n\n` +
          `Was: ${oldOutUi.toFixed(6)} ${sym}\n` +
          `Now: ${freshOutUi.toFixed(6)} ${sym}\n` +
          `Change: ${pctChange.toFixed(2)}%\n\n` +
          `Review the new estimate and click Swap again.`
        );
      }
    }
  }

  log(`Fresh quote: ~${freshOutUi.toFixed(6)} ${MINT_TO_SYMBOL[outputMint] || toSymbol}`, 'info');

  // ============================================================
  // DETERMINE FEE TRANSFER DESTINATION
  // ============================================================
  let feeAccountForTransfer = null;
  let tokenProgramIdForFee = null;
  
  if (feePlan.transferPlan) {
    const plan = feePlan.transferPlan;
    const feeTransferAmount = BigInt(plan.amount || "0");
    
    if (feeTransferAmount <= 0n) {
      log("Transfer plan amount is 0; skipping fee transfer.", "info");
    } else {
      const isSolInput = (inputMint === TOKEN_MINTS.SOL);
    
    if (isSolInput) {
      feeAccountForTransfer = plan.destinationOwner; // wallet
      log(`Using SOL wallet for fee transfer: ${feeAccountForTransfer}`, 'info');
    } else {
      tokenProgramIdForFee = getTokenProgramIdForMint(inputMint);
      
      if (plan.destinationType === "wallet") {
        feeAccountForTransfer = getAssociatedTokenAddress(inputMint, plan.destinationOwner, tokenProgramIdForFee);
        log(`Using ATA for fee recipient wallet: ${feeAccountForTransfer}`, 'info');
      } else if (plan.destinationType === "vault") {
        feeAccountForTransfer = plan.destinationOwner; // token account
        log(`Using vault token account for fee transfer: ${feeAccountForTransfer}`, 'info');
      } else {
        throw new Error(`Unknown destinationType: ${plan.destinationType}`);
      }
    }
    }
  }
  
  // ============================================================
  // ENSURE FEE VAULT EXISTS (for custom tokens)
  // ============================================================
  if (feePlan.jupiterFeeAccount === "NEEDS_WORKER_CREATION") {
    log('Creating fee vault for custom token (this may take 10-30 seconds)...', 'info');
    
    try {
      // Add timeout to the fetch request
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 45000); // 45 second timeout
      
      const ensureResp = await fetch('https://metis-fee-lock.aquavaults0x.workers.dev/ensure', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ mint: inputMint }),
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      
      if (!ensureResp.ok) {
        throw new Error(`Fee vault creation failed: ${ensureResp.status}`);
      }
      
      const ensureData = await ensureResp.json();
      if (!ensureData.ok) {
        throw new Error(ensureData.error || 'Fee vault creation failed');
      }
      
      // Replace the placeholder with actual vault address
      feePlan.jupiterFeeAccount = ensureData.feeAccount;
      log(`Fee vault created: ${feePlan.jupiterFeeAccount}`, 'info');
      
    } catch (err) {
      if (err.name === 'AbortError') {
        throw new Error(
          `Fee vault creation timed out (Solana network may be congested).\n\n` +
          `Please try again in a moment.`
        );
      }
      throw new Error(`Failed to create fee vault: ${err.message}`);
    }
  }

  // ============================================================
  // GET SWAP INSTRUCTIONS FROM JUPITER
  // ============================================================
  log('Getting swap instructions from Jupiter...', 'info');

  const swapPayload = {
    userPublicKey: window.AquaVaultsWallet?.publicKey?.toBase58() || walletPublicKey,
    wrapAndUnwrapSol: true,
    useSharedAccounts: true,
    feeAccount: feePlan.jupiterFeeAccount || undefined,
    prioritizationFeeLamports: priorityFeeLamports === 0 ? "auto" : priorityFeeLamports,
    asLegacyTransaction: false,
    useTokenLedger: false,
    destinationTokenAccount: undefined,
    dynamicComputeUnitLimit: true,
    skipUserAccountsRpcCalls: false,
    quoteResponse: quote,
  };

  const swapResp = await fetch(`${JUPITER_API_BASE}/swap/v1/swap-instructions`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(swapPayload),
  });
  
  if (!swapResp.ok) {
    const errText = await swapResp.text();

    throw new Error(`Jupiter swap API failed (${swapResp.status}): ${errText}`);
  }
  
  const swapData = await swapResp.json();
  log('Swap instructions received from Jupiter', 'info');
  
  // ============================================================
  // BUILD TRANSACTION CLIENT-SIDE
  // ============================================================
  log('Building transaction client-side...', 'info');
  
  const instructions = [];
  
  // Add compute budget instructions
  if (swapData.computeBudgetInstructions) {
    swapData.computeBudgetInstructions.forEach(ix => {
      instructions.push(jupiterInstructionToSolana(ix));
    });
  }
  
  // Add setup instructions
  if (swapData.setupInstructions) {
    swapData.setupInstructions.forEach(ix => {
      instructions.push(jupiterInstructionToSolana(ix));
    });
  }
  
  // Create ATA for fee destination if needed (only for wallet destinations)
  if (
    feePlan.transferPlan &&
    feeAccountForTransfer &&
    inputMint !== TOKEN_MINTS.SOL &&
    feePlan.transferPlan.destinationType === "wallet"
  ) {
    const ataInfo = await connection.getAccountInfo(new solanaWeb3.PublicKey(feeAccountForTransfer));
    
    // Check if ATA create instruction already exists in transaction (from Jupiter or previous code)
    const ataAlreadyInInstructions = instructions.some(ixn => {
      if (!ixn.programId || ixn.programId.toBase58() !== ASSOCIATED_TOKEN_PROGRAM_ID.toBase58()) {
        return false;
      }
      // Check if this ATA instruction references our target ATA
      return ixn.keys?.some(k => k.pubkey.toBase58() === feeAccountForTransfer);
    });
    
    if (ataAlreadyInInstructions) {
      log("Skipping ATA create: ATA instruction already present for this destination.", "info");
    } else if (!ataInfo) {
      const { ix } = createAssociatedTokenAccountIx({
        payer: window.AquaVaultsWallet?.publicKey?.toBase58() || walletPublicKey,
        owner: feePlan.transferPlan.destinationOwner,
        mint: inputMint,
        tokenProgramId: tokenProgramIdForFee || getTokenProgramIdForMint(inputMint),
      });
      instructions.push(ix);
      log(`Creating ATA for fee destination: ${feeAccountForTransfer}`, 'info');
    } else {
      log(`ATA already exists on-chain: ${feeAccountForTransfer}`, 'info');
    }
  }

  // Add fee transfer instruction if needed (BEFORE swap)
  // ============================================================
  // FEE TRANSFER (optional, BEFORE swap)
  // ============================================================
  if (feePlan.transferPlan) {
    const plan = feePlan.transferPlan;
    const feeTransferAmount = BigInt(plan.amount || "0");

    if (feeTransferAmount <= 0n) {
      log("Transfer plan amount is 0; skipping ATA creation and fee transfer.", "info");
    } else {
      // NOTE: ATA creation is handled earlier (single guarded block) to avoid duplicates.

      const isSolInput = (inputMint === TOKEN_MINTS.SOL);

      if (isSolInput) {
        // SOL transfer via System Program
        const userPubkey =
          window.AquaVaultsWallet?.publicKey || new solanaWeb3.PublicKey(walletPublicKey);

        instructions.push(
          solanaWeb3.SystemProgram.transfer({
            fromPubkey: userPubkey,
            toPubkey: new solanaWeb3.PublicKey(plan.destinationOwner),
            lamports: Number(feeTransferAmount),
          })
        );

        log(
          `Added SOL fee transfer: ${feeTransferAmount.toString()} lamports to ${plan.destinationOwner}`,
          "info"
        );
      } else {
        // SPL token transfer - detect token program and use correct transfer type
        const tokenProgramId = tokenProgramIdForFee || getTokenProgramIdForMint(inputMint);

        const userPubkeyStr = window.AquaVaultsWallet?.publicKey?.toBase58() || walletPublicKey;
        const userInputTokenAccount = await getUserTokenAccountForMint(
          userPubkeyStr,
          inputMint,
          tokenProgramId
        );

        if (!userInputTokenAccount) {
          const sym = MINT_TO_SYMBOL[inputMint] || inputMint.slice(0, 8);
          throw new Error(`No ${sym} token account found for fee transfer`);
        }

        const isToken2022 =
          window.TokenRegistry && typeof window.TokenRegistry.isToken2022 === "function"
            ? window.TokenRegistry.isToken2022(inputMint)
            : tokenProgramId.toBase58() === TOKEN_2022_PROGRAM_ID.toBase58();

        const inputDecimals = await getTokenDecimals(inputMint);

        if (isToken2022) {
          instructions.push(
            createSplTransferCheckedIx({
              source: userInputTokenAccount,
              mint: inputMint,
              destination: feeAccountForTransfer,
              owner: userPubkeyStr,
              amount: feeTransferAmount,
              decimals: inputDecimals,
              tokenProgramId,
            })
          );
          log(
            `Added Token-2022 TransferChecked fee: ${feeTransferAmount.toString()} base units (${inputDecimals} decimals)`,
            "info"
          );
        } else {
          instructions.push(
            createSplTransferIx({
              source: userInputTokenAccount,
              destination: feeAccountForTransfer,
              owner: userPubkeyStr,
              amount: feeTransferAmount,
              tokenProgramId,
            })
          );
          log(
            `Added SPL fee transfer: ${feeTransferAmount.toString()} tokens to ${feeAccountForTransfer}`,
            "info"
          );
        }
      }
    }
  }

  
  // Add swap instruction
  if (swapData.swapInstruction) {
    instructions.push(jupiterInstructionToSolana(swapData.swapInstruction));
  }
  
  // Add cleanup instruction
  if (swapData.cleanupInstruction) {
    instructions.push(jupiterInstructionToSolana(swapData.cleanupInstruction));
  }
  
  // Load address lookup tables
  const lookupTableAccounts = [];
  if (swapData.addressLookupTableAddresses && swapData.addressLookupTableAddresses.length > 0) {
    log(`Loading ${swapData.addressLookupTableAddresses.length} address lookup tables...`, 'info');
    
    for (const address of swapData.addressLookupTableAddresses) {
      const result = await connection.getAddressLookupTable(new solanaWeb3.PublicKey(address));
      if (result && result.value) {
        lookupTableAccounts.push(result.value);
      }
    }
  }
  
  // Get blockhash
  const { blockhash, lastValidBlockHeight } = await connection.getLatestBlockhash('confirmed');
  
  // Build transaction message
  const userPubkey = window.AquaVaultsWallet?.publicKey || new solanaWeb3.PublicKey(walletPublicKey);
  const message = new solanaWeb3.TransactionMessage({
    payerKey: userPubkey,
    recentBlockhash: blockhash,
    instructions,
  }).compileToV0Message(lookupTableAccounts);
  
  const tx = new solanaWeb3.VersionedTransaction(message);
  
  log('✅ Transaction built client-side, requesting signature...', 'info');
  
  const wallet = window.AquaVaultsWallet;
  if (!wallet || !wallet.connected) {
    throw new Error('Wallet not connected');
  }
  
  if (!wallet.signTransaction) {
    throw new Error('Wallet does not support transaction signing');
  }
  
  const signStart = Date.now();
  const signedTx = await wallet.signTransaction(tx);
  const signDurationMs = Date.now() - signStart;
  
  // ============================================================
  // SIGNING-DELAY STALENESS PROTECTION
  // ============================================================
  const MAX_SIGN_DELAY_MS = 30000;
  if (signDurationMs > MAX_SIGN_DELAY_MS) {
    throw new Error(
      `⚠️ Signing took too long (${(signDurationMs/1000).toFixed(1)}s).\n\n` +
      `To protect you from stale pricing, this swap was NOT broadcast.\n` +
      `Please click Swap again to get a fresh quote.`
    );
  }
  
  const MAX_QUOTE_AGE_MS = 45000;
  const quoteAgeMs = Date.now() - quoteFetchedAt;
  if (quoteAgeMs > MAX_QUOTE_AGE_MS) {
    throw new Error(
      `⚠️ Quote became stale (${(quoteAgeMs/1000).toFixed(1)}s old) before broadcast.\n\n` +
      `Swap was NOT broadcast. Please click Swap again.`
    );
  }
  
  const rawTx = signedTx.serialize();

  const sig = await connection.sendRawTransaction(rawTx, {
    skipPreflight: false,
    preflightCommitment: 'processed',
    maxRetries: 3,
  });

  log(`Transaction sent: ${sig}`, 'info');
  log('Waiting for confirmation...', 'info');

  const maxWaitTime = 30000;

  const confirmPromise = connection.confirmTransaction(
    {
      signature: sig,
      blockhash,
      lastValidBlockHeight,
    },
    'confirmed'
  );

  let raceDone = false;

  const timeoutPromise = new Promise((resolve, reject) => {
    setTimeout(async () => {
      if (raceDone) return;

      try {
        const statusRes = await connection.getSignatureStatus(sig);
        const status = statusRes?.value?.confirmationStatus;

        if (status === 'confirmed' || status === 'finalized') {
          log(`⏱️ Timeout fired but status check shows confirmed — treating as success.`, 'info');
          resolve({ value: { err: null } });
          return;
        }

        if (status === null || statusRes?.value === null) {
          reject(
            new Error(
              `⏱️ Transaction Expired (not included in a block)\n\n` +
              `The blockhash expired before this transaction was confirmed.\n` +
              `No funds were moved. It is safe to retry.\n\n` +
              `Signature (for records): ${sig}`
            )
          );
          return;
        }

        reject(
          new Error(
            `⏱️ Transaction Confirmation Timeout\n\n` +
            `Transaction was sent but status is: ${status}\n\n` +
            `Check status before retrying:\n` +
            `https://solscan.io/tx/${sig}\n\n` +
            `⚠️ Do NOT retry until you verify the result to avoid double-swaps.`
          )
        );
      } catch (_) {
        reject(
          new Error(
            `⏱️ Transaction Confirmation Timeout\n\n` +
            `Transaction was sent but did not confirm within ${maxWaitTime / 1000}s.\n` +
            `(Could not determine on-chain status.)\n\n` +
            `Check status before retrying:\n` +
            `https://solscan.io/tx/${sig}\n\n` +
            `⚠️ Do NOT retry until you verify the result to avoid double-swaps.`
          )
        );
      }
    }, maxWaitTime);
  });

  const confirmation = await Promise.race([confirmPromise, timeoutPromise]);

  raceDone = true;

  if (confirmation?.value?.err) {
    throw new Error(`Transaction failed: ${JSON.stringify(confirmation.value.err)}`);
  }

  log(`✅ Transaction confirmed: https://solscan.io/tx/${sig}`, 'info');
  
  // ── Volume tracking (fully non-blocking via setTimeout) ──
  // All referenced variables are const declarations in this same try block:
  //   inputMint (line 630), outputMint (line 631), quote (line 715),
  //   feePlan (line 685), sig (line 1097), slippageBps (function param)
  {
    const _sig = sig;
    const _inputMint = quote?.inputMint || inputMint;
    const _inAmount = quote?.inAmount ? String(quote.inAmount) : String(feePlan.amountForQuote);
    const _outputMint = quote?.outputMint || outputMint;
    const _outAmount = quote?.outAmount ? String(quote.outAmount) : null;
    const _slippageBps = slippageBps;
    const _communityId = localStorage.getItem('selectedCommunity') || 'aquavaults';
    setTimeout(async () => {
      try {
        if (!_inputMint || !_inAmount) return;
        const solEquiv = await getSolEquivLamports(_inputMint, _inAmount, _outputMint, _outAmount, _slippageBps);
        if (solEquiv) {
          commitExecutedVolume({
            signature: _sig,
            kind: 'swap',
            communityId: _communityId,
            inputMint: _inputMint,
            inAmount: _inAmount,
            solEquivLamports: String(solEquiv),
          });
        }
      } catch (_) {}
    }, 0);
  }

  lastUiQuoteContext = null;
  
  return {
      signature: sig,
      feeStrategy: feePlan.feeStrategy,
      solscanUrl: `https://solscan.io/tx/${sig}`,
      confirmed: true,
      estimatedOutput: freshOutUi,
    };
  } catch (err) {
    log(`Swap error: ${err?.message || err}`, 'error');
    throw err;
  } finally {
    // Always clear UI quote context after swap attempt (success or error)
    lastUiQuoteContext = null;
  }
}

// ============================================================
// WALLET STATE LISTENER
// ============================================================

// Listen for wallet state changes from the unified wallet widget
window.addEventListener('av:wallet', function(event) {
  const { connected, publicKey } = event.detail || {};
  
  if (connected && publicKey) {
    walletPublicKey = publicKey;
    isWalletConnected = true;
  } else {
    walletPublicKey = null;
    isWalletConnected = false;
  }
});



// ============================================================
// EXPORTS
// ============================================================

window.AquaVaultsSwapper = {
  initializeConnection,
  connectWallet,
  disconnectWallet,
  getBalance,
  getSwapQuote,
  executeSwap,
  get _connection() { return connection; },
  getSelectedCommunity: getSelectedCommunity,
  setCurrentAffiliate: () => {}, // No-op: cannot change affiliate
  setuiAffiliate: () => {}, // No-op: cannot change affiliate
  isConnected: () => {
    // Check both our state and the widget's state
    if (window.AquaVaultsWallet?.connected) {
      return true;
    }
    return isWalletConnected;
  },
  getWalletAddress: () => {
    // Prefer the unified wallet's current state
    if (window.AquaVaultsWallet?.connected && window.AquaVaultsWallet?.publicKeyString) {
      return window.AquaVaultsWallet.publicKeyString;
    }
    return walletPublicKey;
  },
  setWalletConnected: (pubkey) => {
    walletPublicKey = pubkey;
    isWalletConnected = true;
  },
  setWalletDisconnected: () => {
    walletPublicKey = null;
    isWalletConnected = false;
  },
  TOKEN_MINTS,
  TOKEN_VAULTS_AFFILIATE_1,
  TOKEN_VAULTS_AFFILIATE_2,
  AFFILIATE_B_SOL_WALLET,
  getSolEquivLamports,
  commitExecutedVolume
};
;
// token-registry.js - Unified token data store for presets + custom tokens

// ============================================================
// LOGGING WRAPPER
// ============================================================

function log(...args) {
  const LEVELS = new Set(['info', 'success', 'silent-success', 'warning', 'error', 'pending']);
  let type = 'info';
  if (args.length > 1 && typeof args[args.length - 1] === 'string' && LEVELS.has(args[args.length - 1])) {
    type = args.pop();
  }
  const msg = args.map(v => typeof v === 'string' ? v : JSON.stringify(v)).join(' ');
  if (window.debugLog) window.debugLog(msg, type);
  else console.log(msg);
}

// ============================================================
// TOKEN REGISTRY
// ============================================================

// Token program ids (used for Token-2022 detection and safe fee-transfer routing)
// IMPORTANT: do NOT use TOKEN_PROGRAM_ID as an identifier here because swapper.js already
// defines TOKEN_PROGRAM_ID (PublicKey) in the global scope.
const AV_TOKEN_PROGRAM_ID = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA';
const AV_TOKEN_2022_PROGRAM_ID = 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb';

class TokenRegistry {
  constructor() {
    this.tokens = new Map(); // mint -> token metadata
    this.presetOrder = []; // Ordered list of preset mints for UI
    this.initPresets();
    this.loadCustomTokens();
  }

  // Initialize hardcoded presets (your existing 7 tokens)
  initPresets() {
    const presets = [
      {
        mint: 'So11111111111111111111111111111111111111112',
        symbol: 'SOL',
        name: 'Solana',
        decimals: 9,
        logoURI: 'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png',
        isVerified: true,
        isPreset: true,
        tags: ['verified'],
        tokenProgram: AV_TOKEN_PROGRAM_ID,
        isToken2022: false
      },
      {
        mint: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
        symbol: 'USDC',
        name: 'USD Coin',
        decimals: 6,
        logoURI: 'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v/logo.png',
        isVerified: true,
        isPreset: true,
        tags: ['verified'],
        tokenProgram: AV_TOKEN_PROGRAM_ID,
        isToken2022: false
      },
      {
        mint: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        symbol: 'USDT',
        name: 'Tether USD',
        decimals: 6,
        logoURI: 'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB/logo.png',
        isVerified: true,
        isPreset: true,
        tags: ['verified'],
        tokenProgram: AV_TOKEN_PROGRAM_ID,
        isToken2022: false
      },
      {
        mint: '3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq',
        symbol: 'wPOND',
        name: 'Wrapped POND',
        decimals: 3,
        isVerified: false,
        isPreset: true,
        tags: [],
        tokenProgram: AV_TOKEN_PROGRAM_ID,
        isToken2022: false
      },
      {
        mint: 'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A',
        symbol: 'hSOL',
        name: 'Helius Staked SOL',
        decimals: 9,
        isVerified: false,
        isPreset: true,
        tags: [],
        tokenProgram: AV_TOKEN_PROGRAM_ID,
        isToken2022: false
      },
      {
        mint: 'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So',
        symbol: 'mSOL',
        name: 'Marinade Staked SOL',
        decimals: 9,
        isVerified: false,
        isPreset: true,
        tags: [],
        tokenProgram: AV_TOKEN_PROGRAM_ID,
        isToken2022: false
      },
      {
        mint: 'B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B',
        symbol: 'PepeOnSOL',
        name: 'Pepe On Solana',
        decimals: 6,
        isVerified: false,
        isPreset: true,
        tags: [],
        tokenProgram: AV_TOKEN_PROGRAM_ID,
        isToken2022: false
      }
    ];

    presets.forEach(token => {
      this.tokens.set(token.mint, token);
      this.presetOrder.push(token.mint);
    });

    log(`Initialized ${presets.length} preset tokens`, 'silent-success');
  }

  // Load custom tokens from localStorage
  loadCustomTokens() {
    try {
      const stored = localStorage.getItem('aquavaults_custom_tokens');
      if (!stored) return;

      const customs = JSON.parse(stored);
      customs.forEach(token => {
        if (!this.tokens.has(token.mint)) {
          this.tokens.set(token.mint, { ...token, isPreset: false });
        }
      });

      log(`Loaded ${customs.length} custom tokens from storage`, 'info');
    } catch (err) {
      log('Error loading custom tokens:', err, 'error');
    }
  }

  // Save custom tokens to localStorage
  saveCustomTokens() {
    try {
      const customs = Array.from(this.tokens.values()).filter(t => !t.isPreset);
      localStorage.setItem('aquavaults_custom_tokens', JSON.stringify(customs));
    } catch (err) {
      log('Error saving custom tokens:', err, 'error');
    }
  }

  // Add a custom token (from search/paste)
  addToken(tokenData) {
    // Jupiter Tokens v2 uses `id` as the mint and `icon` as the logo URL.
    const token = {
      mint: tokenData.id || tokenData.mint || tokenData.address,
      symbol: tokenData.symbol,
      name: tokenData.name,
      decimals: tokenData.decimals,
      logoURI: tokenData.icon || tokenData.logoURI,
      isVerified:
        tokenData.isVerified === true ||
        tokenData.verified === true ||
        (Array.isArray(tokenData.tags) && tokenData.tags.includes('verified')),
      isPreset: false,
      tags: tokenData.tags || [],
      tokenProgram: tokenData.tokenProgram || tokenData.token_program || AV_TOKEN_PROGRAM_ID,
      isToken2022: (tokenData.tokenProgram || tokenData.token_program || AV_TOKEN_PROGRAM_ID) === AV_TOKEN_2022_PROGRAM_ID
    };

    // Validate required fields
    if (!token.mint || token.decimals === undefined) {
      throw new Error('Token missing required fields (mint, decimals)');
    }

    // If symbol is missing, fall back to a shortened mint for UI display
    if (!token.symbol || typeof token.symbol !== 'string' || !token.symbol.trim()) {
      token.symbol = token.mint.slice(0, 4) + '…' + token.mint.slice(-4);
    }

    this.tokens.set(token.mint, token);
    this.saveCustomTokens();

    log(`Added custom token: ${token.symbol} (${token.mint})`, 'success');
    return token;
  }

  // Remove a custom token (presets cannot be removed)
  removeToken(mint) {
    const token = this.tokens.get(mint);
    if (!token || token.isPreset) {
      log('Cannot remove preset token', 'warning');
      return false;
    }
    this.tokens.delete(mint);
    this.saveCustomTokens();
    log(`Removed custom token: ${token.symbol}`, 'info');
    return true;
  }
  
  // Get token by mint
  get(mint) {
    return this.tokens.get(mint);
  }

  // Get all presets in order
  getPresets() {
    return this.presetOrder.map(mint => this.tokens.get(mint));
  }

  // Get all custom (non-preset) tokens
  getCustoms() {
    return Array.from(this.tokens.values()).filter(t => !t.isPreset);
  }

  // Get all tokens
  getAll() {
    return Array.from(this.tokens.values());
  }

  // Check if token exists
  has(mint) {
    return this.tokens.has(mint);
  }

  // Get decimals for a mint (critical for swap math)
  getDecimals(mint) {
    const token = this.tokens.get(mint);
    if (!token) {
      throw new Error(`Token not found in registry: ${mint}`);
    }
    if (token.decimals === undefined) {
      throw new Error(`Token ${token.symbol} missing decimals (cannot swap safely)`);
    }
    return token.decimals;
  }

  // Get symbol for display
  getSymbol(mint) {
    const token = this.tokens.get(mint);
    if (token) return token.symbol;
    if (!mint || typeof mint !== 'string') return '???';
    return mint.slice(0, 4) + '...';
  }

  // Return the token program id for a mint (Tokenkeg vs Token-2022)
  getTokenProgram(mint) {
  const token = this.tokens.get(mint);
  return (token && token.tokenProgram) ? token.tokenProgram : AV_TOKEN_PROGRAM_ID;
}


  // Convenience: check if a mint is Token-2022
  isToken2022(mint) {
  return this.getTokenProgram(mint) === AV_TOKEN_2022_PROGRAM_ID;
}

}

// ============================================================
// GLOBAL INSTANCE
// ============================================================

window.TokenRegistry = new TokenRegistry();
;
// community-registry.js - Unified community affiliate data store

// ============================================================
// LOGGING WRAPPER
// ============================================================

function log(...args) {
  const LEVELS = new Set(['info', 'success', 'silent-success', 'warning', 'error', 'pending']);
  let type = 'info';
  if (args.length > 1 && typeof args[args.length - 1] === 'string' && LEVELS.has(args[args.length - 1])) {
    type = args.pop();
  }
  const msg = args.map(v => typeof v === 'string' ? v : JSON.stringify(v)).join(' ');
  if (window.debugLog) window.debugLog(msg, type);
  else console.log(msg);
}

// ============================================================
// COMMUNITY REGISTRY
// ============================================================

class CommunityRegistry {
  constructor() {
    this.communities = new Map(); // id -> community data
    this.communityOrder = []; // Ordered list of community IDs for UI
    this.initCommunities();
  }

  // Initialize hardcoded community affiliates
  initCommunities() {
    const communities = [
      {
        id: 'aquavaults',
        name: 'AquaVaults',
        logo: '/assets/logo-transparent.png',
        description: 'A premier Solana swap aggregator with automated trading features where users choice matter and communities are able to earn fees.',
        website: 'https://aquavaults.com',
        socials: {
          twitter: 'https://x.com/aquavaults',
        },
        jupiterAffiliate: '', // J793jNSvzKQ7bbu2ZL4sHxF8mjBtcZ3nFZG5u4Jrpx6T
        tokenVaults: {
          // Token mint address -> fee vault address
          'So11111111111111111111111111111111111111112': 'FPLExQA2aVi1R2gsank2f8aVV7mJNke8LzZc4hcdMQTQ', // SOL
          'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v': '4VhsDo3odQQp3FYK3L4u1DeMgFivauWeXxwdVNY7L4ow', // USDC
          'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB': 'CWwzp3cerMSL91q52FCePf39rzAdc8iASGroALYQ41Ln', // USDT
          '3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq': '738W61KepfEfyRLdjWJNBGTPUtsHP2Z3tQs1ropYyfQG', // wPOND
          'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A': '5CfLwFLkJU9kLvcziVBdbC3aCjDMW9F13xzxuw3HQJ2y', // hSOL
          'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So': 'E4dL4wYuHg1Kg84bBcwjjcr5ZcVwF1EWYpLfJHVBC7jF', // mSOL
          'B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B': 'Abdn3hAgi88LW1GdCRB5s8gpoEKh6xeJc9EmW6dUHWBi', // PepeOnSOL
          '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN': 'DeqCpGPrnYUXwR4sqkXi4UrkLgNoer6SURu3UEEXSuu2', // OFFICIAL TRUMP (TRUMP)
          '27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4': 'E3L1A7Vib38yJ71Gea8T46K3aBUXbhis82Qax7i1MeyH', // JLP
          'pumpCmXqMfrsAkQ5r49WcJnRayYRqmXz6ae8H7H9Dfn': '2zcPArV6HvFF3ZJvErJHDV16HSnh2HBwC8GUSv3FpDi6', // PUMP
          '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh': 'aTw4RzZ2UM9EpXkcZUtgbzWw21ez9b52XkVG7VNC1Mb', // WBTC
          'J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn': 'Ez7pa1U2fH558miutw3gqu2HUWUMCxtsXaRxNAmHYrFj', // Jito Staked SOL (JitoSOL)
          'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN': '7o2CEcFbgWTp7wCRAPC1mLJPP4Xb1AMuAM9imaB8chYd', // Jupiter (JUP)
          'A7bdiYdS5GjqGFtxf17ppRHtDKPkkRqbKtR27dxvQXaS': '9AD9b9ojrqXKA7xYagNbrq1FMjLDJ1KwkhtiMbVxsChc', // ZEC
          'jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v': '4rco1Mruot7TcyJW7F2Sm7ZsN4qGxgR6GsqLnNUs3YNB', // Jupiter Staked SOL (JupSOL)
          'METvsvVRapdj9cFLzq4Tr43xK4tAjQfwX76z3n6mWQL': 'DK3zbF8xch2DStq5mP9Ai5QQ3FePWx3JTsgpTRjXsHLa', // Meteora (MET)
          '4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R': 'AWjULjF8ggTepAjV3Ngf4Y5fjksnCF9bk16MyCW2sRsm', // Raydium (Ray)
          '98sMhvDwXj1RQi5c5Mndm3vPe9cBqPrbLaufMXFNMh5g': 'HrY6ybtJSdkXiCniPVptbzTDmcMK3Rk7EkdWspBgfSdd', // HYPE
          '2zMMhcVQEXDtdE6vsFS7S7D5oUodfJHE8vd1gnBouauv': '8ny2gN5uUotowaGhWNxPC5DjK25EGohdRvfeMAkRejYr', // Pudgy Penguins (PENGU)
        },
        backupWallet: '9PAPuQ12ZPR5vWfrZQE1qEpNDXMWVb45Yyi2EgfGB7Us' // Backup wallet for non-vault tokens
      },
      {
        id: 'pond0x',
        name: 'Pond0x',
        logo: '/assets/pond-logo-transparent.png',
        description: 'Pond0x is a decentralized exchange (DEX) and ecosystem that rewards users for their participation in activities like swapping tokens on Ethereum and Solana, and contributing mining power from any internet capable device. Key tokens include $PNDC, $PORK (on Ethereum), $wPOND, and $pondSOL (on Solana), all tied to the "Crypto 2.0" vision where users are king and participation is rewarded.',
        website: 'https://pond0x.com',
        socials: {
          twitter: '',
        },
        jupiterAffiliate: '', // ETrCXCK7d67MbbY18CnZZWXp8o9b3GAWwwiCVxguouf
        tokenVaults: {
          // Token mint address -> fee vault address
      // 'So11111111111111111111111111111111111111112': '9hCLuXrQrHCU9i7y648Nh7uuWKHUsKDiZ5zyBHdZPWtG', // SOL
      // 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v': '6NqvoPpSYCPEtLEukQaSNs7mS3yK6k285saH9o3vgC96', // USDC
      // 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB': '5LmFGjbae5iWejFVT8UiRLggh1me22nTetmere8SjwKy', // USDT
      // '3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq': 'GKHmDYWPE8Bf74xDntnpx4hi4H7pRp3HK5QYvPyXGEiU', // wPOND
      // 'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A': '4jkVjzXtrCuxQus3neMtLfNL4wZhsPmm9fKGXoLMXqsG', // hSOL
      // 'B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B': '3qGSU2RySrjvQ2iGMts2HZ4ssGVSrBUSGL4jN7LHGhgo', // PepeOnSOL
        },
        backupWallet: '1orFCnFfgwPzSgUaoK6Wr3MjgXZ7mtk8NGz9Hh4iWWL' // Backup wallet for non-vault tokens
      },
      {
        id: 'demplar',
        name: 'Knights Demplar',
        logo: '/assets/demplar-logo.png',
        description: 'Official community for the Demplarverse RPG — adventure, quests, land claims, character cards & Xspace events in a fantasy world on Solana.',
        website: 'https://knightsdemplar.com',
        socials: {
          twitter: 'https://x.com/DemplarOfficial',
          discord: 'https://discord.gg/EyfXFUapAw',        },
        jupiterAffiliate: '', // BB3oWu9RuGqruG72DnpcorNECCHvkutShhrA5yS2BPey
        tokenVaults: {
          // Token mint address -> fee vault address
          'So11111111111111111111111111111111111111112': '66eVsh7mjgaUpvpFPkGZz2tVawMD8SsSLJFaRHfBnMV2', // SOL
          'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v': 'D5nu3uhRUEtg4LKsQWaLTKZm2kuWr5b6eECHmzsfJwyZ', // USDC
          'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB': 'FFcjeh1zSHUs28QbD3jaEYFaANBZymXwEqAp8kkX8Pvo', // USDT
          '3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq': '9Fj7946DGezyBHVDszXqomTXi9QkBzewZdPmvp5qcB24', // wPOND
          'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A': '3XHaLXZ9JeSoyp1zpvbokSawS41TzMEwTRfsEMyHG89U', // hSOL
          'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So': 'CUMyunJB4m9nsdAwvJiBoUC5N95fWM8rVPHjVk7ke2E3', // mSOL
          '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh': 'y1xbqnDtoxFw6BgfCcyunqU6SrUmJdNZ8ttey2hPR4E', // WBTC
          '27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4': 'CHoGcdW3W5HLbNX4RqBVHhDYtWyUyWxiBTbLzAgazhZE', // JLP
          '2zMMhcVQEXDtdE6vsFS7S7D5oUodfJHE8vd1gnBouauv': '95nq7FRHt6DHFd7Pw3QPw4D1kf7c1zzJCM31oE93oX4W', // Pudgy Penguins (PENGU)
          '5UUH9RTDiSpq6HKS6bp4NdU9PNJpXRXuiw6ShBTBhgH2': '6k43fDMasbmRCX1iojSQb1MviGtbHEq9cmpasU1ofYrq', // TROLL
          'METvsvVRapdj9cFLzq4Tr43xK4tAjQfwX76z3n6mWQL': 'JBrYLP2dtMJoYZJp5BwMKmrqZRy4GhT2BbSfQRmXa4KS', // Meteora (MET)
          'A7bdiYdS5GjqGFtxf17ppRHtDKPkkRqbKtR27dxvQXaS': '6uGhmjQ5ynSyspFypZQ34DeSpft1v8BPnLaNKvuErTVY', // ZEC
          'J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn': '5ft9xv9mzRHNQeSm37Ui4aFjgBvwJVsRgAFiD2cpWJnc', // Jito Staked SOL (JitoSOL)
          'jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v': 'C2gPZWUvre2HQaFLMfT5w2ezkNNHaeyRpaZuMcgXM7AE', // Jupiter Staked SOL (JupSOL)
          'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN': '3Vagfe28PsPZofUy5vT2SwJRcJCjHpJMRU791xD7YBfe', // Jupiter (JUP)
          '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN': 'GYHFVRWsPxfTVdoeHvooh76BGyC5KyZE5J7Lu58NTLPF', // OFFICIAL TRUMP (TRUMP)
        },
        backupWallet: 'DWtssZrEGeSqfskKWBXG5LUiocXobNHtK2cai6rFBazj' // Backup wallet for non-vault tokens
      }
      // Additional communities will be added here
    ];

    communities.forEach(community => {
      this.communities.set(community.id, community);
      this.communityOrder.push(community.id);
    });

    log(`Initialized ${communities.length} community affiliate(s)`, 'silent-success');
  }

  // Get community by ID
  get(id) {
    return this.communities.get(id);
  }

  // Get all communities in order
  getAll() {
    return this.communityOrder.map(id => this.communities.get(id));
  }

  // Check if community exists
  has(id) {
    return this.communities.has(id);
  }

  // Get fee destination for a specific token mint
  // Returns the token vault if available, otherwise returns backup wallet
  getFeeDestination(communityId, tokenMint) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }

    // Check if there's a specific vault for this token
    if (community.tokenVaults && community.tokenVaults[tokenMint]) {
      return community.tokenVaults[tokenMint];
    }

    // Fallback to backup wallet
    if (!community.backupWallet) {
      throw new Error(`Community ${communityId} has no backup wallet configured`);
    }

    return community.backupWallet;
  }

  // Get Jupiter affiliate account for a community
  getAffiliateAccount(communityId) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }
    if (!community.jupiterAffiliate) {
      throw new Error(`Community ${communityId} has no Jupiter affiliate account configured`);
    }
    return community.jupiterAffiliate;
  }

  // Check if a community has a specific token vault
  hasTokenVault(communityId, tokenMint) {
    const community = this.communities.get(communityId);
    if (!community) return false;
    return !!(community.tokenVaults && community.tokenVaults[tokenMint]);
  }
  // Get backup wallet for a community (always returns wallet address, never vault)
  getBackupWallet(communityId) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }
    if (!community.backupWallet) {
      throw new Error(`Community ${communityId} has no backup wallet configured`);
    }
    return community.backupWallet;
  }

  // Get token vault for a specific mint (returns vault address or null, never wallet)
  getTokenVault(communityId, tokenMint) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }
    return (community.tokenVaults && community.tokenVaults[tokenMint]) || null;
  }
}

// ============================================================
// GLOBAL INSTANCE
// ============================================================

window.CommunityRegistry = new CommunityRegistry();
;
// token-meta-cache.js — Two-layer token metadata caching
// Layer 1: In-memory Map (instant, per page session)
// Layer 2: localStorage (persists across page loads, per user)
// Upstream: /api/tokenmeta (KV worker, shared across all users)
// Fallback: /api/jupiter/tokens/v2/search (existing proxy, no KV)
//
// Load this BEFORE token-picker.js on any page that uses the picker.
// Provides: window.TokenMetaCache.getMintMeta(mint)
//           window.TokenMetaCache.getBatchMintMeta([mint, ...])
//           window.TokenMetaCache.searchTokens(query)

(() => {
  'use strict';

  // ============================================================
  // CONFIG
  // ============================================================

  const LS_MINT_PREFIX   = 'av:tmeta:';    // localStorage key prefix for mint metadata
  const LS_SEARCH_PREFIX = 'av:tsearch:';  // localStorage key prefix for search results

  const TTL_MINT_HIT_MS  = 30 * 24 * 60 * 60 * 1000; // 30 days — token metadata is very stable
  const TTL_MINT_MISS_MS = 60 * 60 * 1000;            // 1 hour  — retry unknown mints later
  const TTL_SEARCH_MS    = 10 * 60 * 1000;            // 10 min  — search results refresh slowly

  const BATCH_MAX        = 50;  // max mints per KV worker batch request

  // ============================================================
  // MEMORY CACHES
  // ============================================================

  const memMint     = new Map();  // mint -> { meta, fetchedAt }
  const memInflight = new Map();  // mint -> Promise<meta|null>  (single-flight dedup)
  const memSearch   = new Map();  // queryLower -> { results, fetchedAt }

  // ============================================================
  // HELPERS
  // ============================================================

  function now() { return Date.now(); }

  function lsGet(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
  }
  function lsSet(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
  }
  function lsDel(key) {
    try { localStorage.removeItem(key); } catch {}
  }

  function isExpired(entry, ttl) {
    if (!entry || typeof entry.fetchedAt !== 'number') return true;
    return (now() - entry.fetchedAt) > ttl;
  }

  // Normalize any Jupiter token object shape into a consistent format
  function normalize(t) {
    if (!t) return null;
    const mint = t.address || t.mint || t.id || null;
    if (!mint) return null;
    return {
      mint,
      address: mint,
      symbol:   t.symbol   || '',
      name:     t.name     || '',
      decimals: typeof t.decimals === 'number' ? t.decimals : null,
      logoURI:  t.icon || t.logoURI || t.logo || '',
      tags:     t.tags || [],
      isVerified:
        t.isVerified === true ||
        t.verified === true ||
        (Array.isArray(t.tags) && t.tags.includes('verified')),
      tokenProgram: t.tokenProgram || t.token_program || null,
    };
  }

  // ============================================================
  // LOGGING (reuses debug console if present)
  // ============================================================

  function log(msg, type) {
    if (window.debugLog) window.debugLog(msg, type || 'info');
    else console.log('[TokenMetaCache]', msg);
  }

  // ============================================================
  // SINGLE-MINT LOOKUP: getMintMeta(mint)
  //
  // Resolution order:
  //   1. Memory cache (instant)
  //   2. localStorage cache (fast)
  //   3. /api/tokenmeta?mint=X  (KV worker — shared cache)
  //   4. /api/jupiter/tokens/v2/search?query=X  (Jupiter proxy — no KV)
  // ============================================================

  async function getMintMeta(mint) {
    if (!mint || typeof mint !== 'string') return null;
    mint = mint.trim();

    // ── 1. Memory hit ──
    const mem = memMint.get(mint);
    if (mem) {
      const ttl = mem.meta ? TTL_MINT_HIT_MS : TTL_MINT_MISS_MS;
      if (!isExpired(mem, ttl)) return mem.meta;
      // expired — fall through
    }

    // ── 2. localStorage hit ──
    const lsKey = LS_MINT_PREFIX + mint;
    const ls = lsGet(lsKey);
    if (ls) {
      const ttl = ls.meta ? TTL_MINT_HIT_MS : TTL_MINT_MISS_MS;
      if (!isExpired(ls, ttl)) {
        memMint.set(mint, ls);
        return ls.meta;
      }
      // expired — fall through
    }

    // ── 3. Single-flight dedup (prevent duplicate concurrent fetches for same mint) ──
    if (memInflight.has(mint)) return memInflight.get(mint);

    const promise = _fetchAndCacheSingleMint(mint);
    memInflight.set(mint, promise);

    return promise;
  }

  async function _fetchAndCacheSingleMint(mint) {
    try {
      let meta = null;

      // Try KV worker first
      try {
        const res = await fetch(`/api/tokenmeta?mint=${encodeURIComponent(mint)}`);
        if (res.ok) {
          const data = await res.json();
          if (data && !data.notFound) {
            meta = normalize(data);
          }
        }
      } catch { /* KV worker unavailable — fall through */ }

      // Fallback: Jupiter search proxy
      if (!meta) {
        try {
          const res = await fetch(`/api/jupiter/tokens/v2/search?query=${encodeURIComponent(mint)}`);
          if (res.ok) {
            const arr = await res.json();
            const tokens = Array.isArray(arr) ? arr : (arr.tokens || arr.data || []);
            const exact = tokens.find(t => (t.address || t.id || t.mint) === mint) || tokens[0] || null;
            meta = normalize(exact);
          }
        } catch { /* Jupiter also failed */ }
      }

      // Cache result (hit or miss)
      const entry = { meta, fetchedAt: now() };
      memMint.set(mint, entry);
      lsSet(LS_MINT_PREFIX + mint, entry);

      return meta;

    } finally {
      memInflight.delete(mint);
    }
  }

  // ============================================================
  // BATCH-MINT LOOKUP: getBatchMintMeta([mint, ...])
  //
  // Returns: Map<mint, normalizedMeta|null>
  //
  // Resolution order:
  //   1. Check memory + localStorage for each mint
  //   2. Send uncached mints to /api/tokenmeta?mints=X,Y,Z  (KV worker)
  //   3. Any still-missing mints fall back to Jupiter proxy
  //   4. Cache all results
  // ============================================================

  async function getBatchMintMeta(mints) {
    if (!Array.isArray(mints)) return new Map();

    const unique = [...new Set(mints.filter(m => m && typeof m === 'string'))];
    const result = new Map();   // mint -> meta|null
    const uncached = [];        // mints that need upstream fetch

    // ── 1. Check memory + localStorage for each mint ──
    for (const mint of unique) {
      // Memory
      const mem = memMint.get(mint);
      if (mem) {
        const ttl = mem.meta ? TTL_MINT_HIT_MS : TTL_MINT_MISS_MS;
        if (!isExpired(mem, ttl)) {
          result.set(mint, mem.meta);
          continue;
        }
      }
      // localStorage
      const ls = lsGet(LS_MINT_PREFIX + mint);
      if (ls) {
        const ttl = ls.meta ? TTL_MINT_HIT_MS : TTL_MINT_MISS_MS;
        if (!isExpired(ls, ttl)) {
          memMint.set(mint, ls);
          result.set(mint, ls.meta);
          continue;
        }
      }
      uncached.push(mint);
    }

    if (uncached.length === 0) return result;

    // ── 2. Ask KV worker for uncached mints (in chunks) ──
    const stillMissing = [];

    for (let i = 0; i < uncached.length; i += BATCH_MAX) {
      const chunk = uncached.slice(i, i + BATCH_MAX);
      try {
        const qs = chunk.map(m => encodeURIComponent(m)).join(',');
        const res = await fetch(`/api/tokenmeta?mints=${qs}`);
        if (res.ok) {
          const data = await res.json();
          // Expect: { results: { mint: tokenObj|null, ... } }
          const map = data.results || data;
          for (const mint of chunk) {
            const raw = map[mint];
            if (raw && !raw.notFound) {
              const meta = normalize(raw);
              result.set(mint, meta);
              const entry = { meta, fetchedAt: now() };
              memMint.set(mint, entry);
              lsSet(LS_MINT_PREFIX + mint, entry);
            } else {
              stillMissing.push(mint);
            }
          }
        } else {
          // KV worker returned error — everything in this chunk is still missing
          stillMissing.push(...chunk);
        }
      } catch {
        // KV worker unreachable — everything in this chunk is still missing
        stillMissing.push(...chunk);
      }
    }

// ── 3. Fallback: Jupiter proxy search (documented: comma-separated mints, max 100) ──
    if (stillMissing.length > 0) {
      // Chunk into groups of 100 (Jupiter search limit per query)
      for (let i = 0; i < stillMissing.length; i += 100) {
        const chunk = stillMissing.slice(i, i + 100);
        try {
          const query = chunk.join(',');
          const res = await fetch(`/api/jupiter/tokens/v2/search?query=${encodeURIComponent(query)}`);
          if (res.ok) {
            const data = await res.json();
            const tokens = Array.isArray(data) ? data : (data.tokens || data.data || []);
            for (const t of tokens) {
              const m = t.address || t.id || t.mint;
              if (m && stillMissing.includes(m)) {
                const meta = normalize(t);
                result.set(m, meta);
                const entry = { meta, fetchedAt: now() };
                memMint.set(m, entry);
                lsSet(LS_MINT_PREFIX + m, entry);
              }
            }
          }
        } catch {
          log('Jupiter search fallback failed for chunk', 'warning');
        }
      }
    }

    // ── 4. Negative-cache anything that's still missing ──
    for (const mint of uncached) {
      if (!result.has(mint)) {
        result.set(mint, null);
        const entry = { meta: null, fetchedAt: now() };
        memMint.set(mint, entry);
        lsSet(LS_MINT_PREFIX + mint, entry);
      }
    }

    return result;
  }

  // ============================================================
  // SEARCH: searchTokens(query)
  //
  // Resolution order:
  //   1. Memory search cache (10 min TTL)
  //   2. localStorage search cache (10 min TTL)
  //   3. /api/jupiter/tokens/v2/search?query=X  (existing proxy)
  //   4. Cache result in both layers
  //
  // Returns: array of raw Jupiter token objects (NOT normalized,
  //          so token-picker.js can render badges/icons as-is)
  // ============================================================

  async function searchTokens(query) {
    if (!query || typeof query !== 'string') return [];
    query = query.trim();
    if (!query) return [];

    const cacheKey = query.toLowerCase();

    // ── 1. Memory search cache ──
    const mem = memSearch.get(cacheKey);
    if (mem && !isExpired(mem, TTL_SEARCH_MS)) {
      return mem.results;
    }

    // ── 2. localStorage search cache ──
    const lsKey = LS_SEARCH_PREFIX + cacheKey;
    const ls = lsGet(lsKey);
    if (ls && !isExpired(ls, TTL_SEARCH_MS)) {
      memSearch.set(cacheKey, ls);
      return ls.results;
    }

    // ── 3. Fetch from Jupiter proxy ──
    const url = `/api/jupiter/tokens/v2/search?query=${encodeURIComponent(query)}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Jupiter search HTTP ${res.status}`);
    const data = await res.json();
    const results = Array.isArray(data) ? data : (data.tokens || data.data || []);

    // ── 4. Cache in both layers ──
    const entry = { results, fetchedAt: now() };
    memSearch.set(cacheKey, entry);
    lsSet(lsKey, entry);

    // Bonus: seed the mint cache with any results that contain full metadata
    for (const t of results) {
      const mint = t.address || t.id || t.mint;
      if (mint && !memMint.has(mint)) {
        const meta = normalize(t);
        if (meta && meta.decimals !== null) {
          const e = { meta, fetchedAt: now() };
          memMint.set(mint, e);
          lsSet(LS_MINT_PREFIX + mint, e);
        }
      }
    }

    return results;
  }

  // ============================================================
  // CACHE MANAGEMENT
  // ============================================================

  // Evict a specific mint from all cache layers (use after token removal)
  function evictMint(mint) {
    memMint.delete(mint);
    memInflight.delete(mint);
    lsDel(LS_MINT_PREFIX + mint);
  }

  // Purge all TokenMetaCache data from localStorage
  // (call if localStorage is getting too large)
  function purgeAll() {
    memMint.clear();
    memInflight.clear();
    memSearch.clear();

    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith(LS_MINT_PREFIX) || key.startsWith(LS_SEARCH_PREFIX))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(k => localStorage.removeItem(k));

    log(`Purged ${keysToRemove.length} cached entries`, 'info');
  }

  // Get cache stats for debugging
  function stats() {
    let lsCount = 0;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith(LS_MINT_PREFIX) || key.startsWith(LS_SEARCH_PREFIX))) {
        lsCount++;
      }
    }
    return {
      memoryMints: memMint.size,
      memorySearches: memSearch.size,
      inflight: memInflight.size,
      localStorageEntries: lsCount,
    };
  }

  // ============================================================
  // EXPORT
  // ============================================================

  window.TokenMetaCache = {
    getMintMeta,
    getBatchMintMeta,
    searchTokens,
    evictMint,
    purgeAll,
    stats,
  };

  log('TokenMetaCache initialized', 'silent-success');
})();

;
// token-picker.js - Token search/selection modal

// ============================================================
// LOGGING WRAPPER
// ============================================================

function log(...args) {
  const LEVELS = new Set(['info', 'success', 'silent-success', 'warning', 'error', 'pending']);
  let type = 'info';
  if (
    args.length > 1 &&
    typeof args[args.length - 1] === 'string' &&
    LEVELS.has(args[args.length - 1])
  ) {
    type = args.pop();
  }
  const msg = args.map(v => (typeof v === 'string' ? v : JSON.stringify(v))).join(' ');
  if (window.debugLog) window.debugLog(msg, type);
  else console.log(msg);
}

// ============================================================
// TOKEN PICKER
// ============================================================

class TokenPicker {
  constructor() {
    this.overlay = null;
    this.resultsContainer = null;
    this.searchInput = null;
    this.callback = null;
    this.searchTimeout = null;

    this.unverifiedTokenCache = new Set(); // Track which tokens user has confirmed
    this.currentResults = []; // Cache last results (avoid embedding JSON in HTML)

    this.walletSection = null;
    this.walletResults = null;
    this.walletToggle = null;

    this.walletTokensCache = [];
    this.walletTokensCacheTimestamp = 0;
  }

  init() {
    this.overlay = document.getElementById('tokenPickerOverlay');
    this.resultsContainer = document.getElementById('tokenPickerResults');
    this.searchInput = document.getElementById('tokenPickerSearch');

    const closeBtn = document.getElementById('tokenPickerClose');
    const searchBtn = document.getElementById('tokenPickerSearchBtn');

    // Wire up events
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (searchBtn) searchBtn.addEventListener('click', () => this.handleSearch());
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.handleSearchDebounced());
      this.searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') this.handleSearch();
      });
    }

    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
    }

    log('Token picker initialized', 'silent-success');

    // Initialize wallet tokens section
    this.walletSection = document.getElementById('tokenPickerWalletSection');
    this.walletResults = document.getElementById('tokenPickerWalletResults');
    this.walletToggle = document.getElementById('tokenPickerWalletToggle');

    if (this.walletSection && this.walletToggle) {
      const toggleBtn = document.getElementById('tokenPickerWalletToggle');
      if (toggleBtn) toggleBtn.addEventListener('click', () => this.toggleWalletSection());
      const header = this.walletSection.querySelector('.token-picker-wallet-header');
      if (header) header.addEventListener('click', () => this.toggleWalletSection());
    }
  }

  open(side, callback) {
    // backward-compat: swap-card / autoswap-card call open(callbackFn) with one arg
    if (typeof side === 'function') {
      callback = side;
      side = null;
    }
    this.callback = callback;
    if (this.overlay) this.overlay.style.display = 'flex';
    if (this.searchInput) {
      this.searchInput.value = '';
      this.searchInput.focus();
    }
    this.showEmptyState();
    this.loadWalletTokens();
  }

  close() {
    if (this.overlay) this.overlay.style.display = 'none';
    this.callback = null;
    this.showEmptyState();
    window.dispatchEvent(new CustomEvent('tokenPickerClosed'));
  }

  handleSearchDebounced() {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.handleSearch(), 500);
  }

  async handleSearch() {
    const query = this.searchInput?.value?.trim() || '';
    if (!query) {
      this.showEmptyState();
      return;
    }

    this.showLoading();

    try {
      // TokenMetaCache: memory → localStorage (10 min TTL) → Jupiter proxy
      // Falls back to direct fetch if TokenMetaCache is not loaded
      let data;
      if (window.TokenMetaCache && typeof window.TokenMetaCache.searchTokens === 'function') {
        data = await window.TokenMetaCache.searchTokens(query);
      } else {
        const response = await fetch(`/api/jupiter/tokens/v2/search?query=${encodeURIComponent(query)}`);
        if (!response.ok) throw new Error(`Search failed: ${response.status}`);
        data = await response.json();
        if (!Array.isArray(data)) data = data.tokens || data.data || [];
      }

      if (!data || data.length === 0) {
        this.showNoResults();
        return;
      }

      this.showResults(data);
    } catch (err) {
      log('Token search error:', err, 'error');
      this.showError(err?.message || 'Token search failed');
    }
  }

  _escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = String(text ?? '');
    return div.innerHTML;
  }

  _sanitizeUrl(url) {
    if (!url || typeof url !== 'string') return '';
    const trimmed = url.trim();
    if (trimmed.startsWith('https://') || trimmed.startsWith('http://')) return trimmed;
    return '';
  }
  
  showResults(tokens) {
    if (!this.resultsContainer) return;

    // Cache tokens in memory to avoid embedding JSON in HTML attributes (XSS risk)
    this.currentResults = Array.isArray(tokens) ? tokens : [];

    this.resultsContainer.innerHTML = this.currentResults
      .map((token, i) => {
        // Jupiter Tokens v2 returns `id` (mint) and `icon`
        const mintRaw = token.id || token.address || token.mint;
        const mint = this._escapeHtml(mintRaw);
        const symbol = this._escapeHtml(token.symbol || '???');
        const name = this._escapeHtml(token.name || 'Unknown Token');

        // Prefer Jupiter-provided `icon` (v2) / `logoURI` (legacy); otherwise fallback
        const logoURI = this._sanitizeUrl(token.icon || token.logoURI || this.getFallbackIconUrl(mintRaw));

        // Robust verification detection (Jupiter can expose this as a boolean field)
        const isVerified =
          token.isVerified === true ||
          token.verified === true ||
          (Array.isArray(token.tags) && token.tags.includes('verified'));

        const isToken2022 = (token.tokenProgram || token.token_program) === 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb';

        const badges = [];
        if (isVerified) {
          badges.push('<span class="token-picker-badge token-picker-badge-verified">✓ Verified</span>');
        } else {
          badges.push('<span class="token-picker-badge token-picker-badge-unverified">⚠️ Unverified</span>');
        }
        if (isToken2022) {
          badges.push('<span class="token-picker-badge token-picker-badge-token2022">Token-2022</span>');
        }

        // Keep icons quiet (no console spam); fall back to letter if image fails
        const iconHTML = logoURI
          ? `<img src="${logoURI}"
                  alt="${symbol}"
                  onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
               <div class="token-picker-result-icon-fallback" style="display:none;">${symbol.charAt(0)}</div>`
          : `<div class="token-picker-result-icon-fallback">${symbol.charAt(0)}</div>`;

        return `
          <div class="token-picker-result" data-idx="${i}">
            <div class="token-picker-result-icon">
              ${iconHTML}
            </div>
            <div class="token-picker-result-info">
              <div class="token-picker-result-header">
                <span class="token-picker-result-symbol">${symbol}</span>
                ${badges.join('')}
              </div>
              <div class="token-picker-result-name">${name}</div>
              <div class="token-picker-result-ca-row">
                <div class="token-picker-result-ca">
                  <span class="token-picker-ca-label">CA:</span>
                  <span class="token-picker-ca-address" title="${mint}">${mint}</span>
                  <button class="token-picker-copy-btn"
                          data-copy="${mint}"
                          title="Copy address">📋</button>
                </div>
                <a href="https://solscan.io/token/${mint}"
                   target="_blank"
                   class="token-picker-solscan-link"
                   onclick="event.stopPropagation();"
                   title="View on Solscan">
                  🔍 Solscan
                </a>
              </div>
            </div>
          </div>
        `;
      })
      .join('');

    // Wire up click handlers for selection
    this.resultsContainer.querySelectorAll('.token-picker-result').forEach(el => {
      el.addEventListener('click', () => this.handleTokenSelect(el));
    });

    // Wire copy buttons safely (no inline `this` scope issues)
    this.resultsContainer.querySelectorAll('.token-picker-copy-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const mint = btn.getAttribute('data-copy') || '';
        if (!mint) return;

        try {
          await navigator.clipboard.writeText(mint);
          const prev = btn.textContent;
          btn.textContent = '✓ Copied';
          setTimeout(() => (btn.textContent = prev), 1000);
        } catch {
          alert('Copy failed — please copy manually:\n' + mint);
        }
      });
    });
  }

  async handleTokenSelect(element) {
    try {
      const idx = Number(element.getAttribute('data-idx'));
      const raw = this.currentResults[idx];
      if (!raw) throw new Error('Selected token not found in results cache');

      // Normalize Jupiter token shape so downstream code always has BOTH `mint` and `address`
      // Jupiter Tokens v2 uses `id` as the mint address.
      const tokenData = {
        ...raw,
        mint: raw.id || raw.mint || raw.address,
        address: raw.address || raw.mint || raw.id
      };

      const cacheKey = tokenData.mint;

      // GOTCHA A: Spoofed/Scam Token Protection
      const isVerified =
        tokenData.isVerified === true ||
        tokenData.verified === true ||
        (Array.isArray(tokenData.tags) && tokenData.tags.includes('verified'));

      if (!isVerified && !this.unverifiedTokenCache.has(cacheKey)) {
        const confirmed = await this.confirmUnverifiedToken(tokenData);
        if (!confirmed) return;
        this.unverifiedTokenCache.add(cacheKey);
      }

      // GOTCHA B: Decimals Validation
      if (tokenData.decimals === undefined) {
        alert(
          '⚠️ Token decimals unavailable — cannot safely compute swap amounts.\n\nPlease try a different token.'
        );
        return;
      }

      // GOTCHA C: Token-2022 Warning
      const isToken2022 = (tokenData.tokenProgram || tokenData.token_program) === 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb';
      if (isToken2022) {
        const proceed = confirm(
          '⚠️ This token uses Token-2022 program.\n\n' +
          'Wallet and protocol support may vary. Proceed with caution.\n\n' +
          'Continue anyway?'
        );
        if (!proceed) return;
      }

      // Add to registry
      const token = window.TokenRegistry.addToken(tokenData);

      // Call callback (updates dropdown)
      if (this.callback) {
        this.callback(token);
      }

      this.close();
    } catch (err) {
      log('Token select error:', err, 'error');
      alert('Error adding token: ' + (err?.message || String(err)));
      this.close();
    }
  }

  async confirmUnverifiedToken(tokenData) {
    const symbol = tokenData.symbol || '???';
    const mint = (tokenData.id || tokenData.mint || tokenData.address || '').slice(0, 8) + '...';

    return new Promise((resolve) => {
      const confirmed = confirm(
        `⚠️ UNVERIFIED TOKEN WARNING\n\n` +
        `Token: ${symbol}\n` +
        `Mint: ${mint}\n\n` +
        `This token is not verified by Jupiter. It may be:\n` +
        `• Spoofed / fake version of a real token\n` +
        `• Malicious contract\n` +
        `• Scam token\n\n` +
        `You are responsible for verifying the mint address is correct.\n\n` +
        `☑️ I understand the risks and have verified this mint address\n\n` +
        `Proceed with this token?`
      );
      resolve(confirmed);
    });
  }

  showEmptyState() {
    if (!this.resultsContainer) return;

    const customs = window.TokenRegistry ? window.TokenRegistry.getCustoms() : [];

    if (customs.length > 0) {
      this.showMyTokens(customs);
    } else {
      this.resultsContainer.innerHTML = `
        <div class="token-picker-empty">
          Type to search by name/symbol, or paste a full Solana token mint address
        </div>
      `;
    }
  }

  showMyTokens(customs) {
    if (!this.resultsContainer) return;

    this.resultsContainer.innerHTML = `
      <div class="token-picker-my-tokens-header">My Tokens</div>
      ${customs.map(token => {
        const logoURI = token.logoURI || '';
        const iconHTML = logoURI
          ? `<img src="${logoURI}" alt="${token.symbol}"
                onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
             <div class="token-picker-result-icon-fallback" style="display:none;">${token.symbol.charAt(0)}</div>`
          : `<div class="token-picker-result-icon-fallback">${token.symbol.charAt(0)}</div>`;

        const verifiedBadge = token.isVerified
          ? '<span class="token-picker-badge token-picker-badge-verified">✓ Verified</span>'
          : '<span class="token-picker-badge token-picker-badge-unverified">⚠️ Unverified</span>';

        return `
          <div class="token-picker-result token-picker-my-token" data-mint="${token.mint}">
            <div class="token-picker-result-icon">${iconHTML}</div>
            <div class="token-picker-result-info">
              <div class="token-picker-result-header">
                <span class="token-picker-result-symbol">${token.symbol}</span>
                ${verifiedBadge}
              </div>
              <div class="token-picker-result-name">${token.name || ''}</div>
              <div class="token-picker-result-ca-row">
                <div class="token-picker-result-ca">
                  <span class="token-picker-ca-label">CA:</span>
                  <span class="token-picker-ca-address" title="${token.mint}">${token.mint}</span>
                  <button class="token-picker-copy-btn"
                          data-copy="${token.mint}"
                          title="Copy address">📋</button>
                </div>
                <a href="https://solscan.io/token/${token.mint}"
                   target="_blank"
                   class="token-picker-solscan-link"
                   onclick="event.stopPropagation();"
                   title="View on Solscan">
                  🔍 Solscan
                </a>
              </div>
            </div>
            <button class="token-picker-delete-btn" title="Remove token">🗑️</button>
          </div>
        `;
      }).join('')}
      <div class="token-picker-empty" style="padding: 1.5rem 1rem;">
        Or search by name/symbol, or paste a mint address
      </div>
    `;

    // Wire selection clicks on rows
    this.resultsContainer.querySelectorAll('.token-picker-my-token').forEach(el => {
      el.addEventListener('click', () => {
        const mint = el.getAttribute('data-mint');
        const token = window.TokenRegistry.get(mint);
        if (token && this.callback) {
          this.callback(token);
          this.close();
        }
      });
    });

    // Wire delete buttons
    this.resultsContainer.querySelectorAll('.token-picker-delete-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const row = btn.closest('.token-picker-my-token');
        const mint = row?.getAttribute('data-mint');
        if (!mint) return;

        const token = window.TokenRegistry.get(mint);
        const symbol = token ? token.symbol : 'Token';

        // Remove from registry + localStorage
        window.TokenRegistry.removeToken(mint);

        // Remove from all dropdowns on the page immediately
        document.querySelectorAll(`select option[value="${mint}"]`).forEach(opt => opt.remove());

        // Remove the row from the modal
        row.remove();

        log(`Removed ${symbol} from custom tokens`, 'info');

        // If no custom tokens left, show the default empty state
        if (!this.resultsContainer.querySelector('.token-picker-my-token')) {
          this.showEmptyState();
        }
      });
    });

    // Wire copy buttons
    this.resultsContainer.querySelectorAll('.token-picker-copy-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const mint = btn.getAttribute('data-copy') || '';
        if (!mint) return;

        try {
          await navigator.clipboard.writeText(mint);
          const prev = btn.textContent;
          btn.textContent = '✓ Copied';
          setTimeout(() => (btn.textContent = prev), 1000);
        } catch {
          alert('Copy failed — please copy manually:\n' + mint);
        }
      });
    });
  }

  showLoading() {
    if (!this.resultsContainer) return;
    this.resultsContainer.innerHTML = `
      <div class="token-picker-loading">
        🔍 Searching tokens...
      </div>
    `;
  }

  showNoResults() {
    if (!this.resultsContainer) return;
    this.resultsContainer.innerHTML = `
      <div class="token-picker-empty">
        No tokens found. Try a different search or paste a mint address.
      </div>
    `;
  }

  showError(message) {
    if (!this.resultsContainer) return;
    this.resultsContainer.innerHTML = `
      <div class="token-picker-error">
        ⚠️ Search error: ${message}
      </div>
    `;
  }

  toggleWalletSection() {
    if (!this.walletResults || !this.walletToggle) return;

    const isExpanded = this.walletResults.classList.contains('expanded');

    if (isExpanded) {
      this.walletResults.classList.remove('expanded');
      this.walletToggle.classList.remove('expanded');
    } else {
      this.walletResults.classList.add('expanded');
      this.walletToggle.classList.add('expanded');
    }
  }

  async loadWalletTokens() {
    // Check if wallet is connected via AquaVaultsWallet
    // Race condition: picker may open before auto-connect finishes.
    // Retry once after a short delay if wallet appears disconnected.
    if (!window.AquaVaultsWallet?.connected || !window.AquaVaultsWallet?.publicKey) {
      await new Promise(r => setTimeout(r, 1500));
      if (!window.AquaVaultsWallet?.connected || !window.AquaVaultsWallet?.publicKey) {
        // Wallet genuinely not connected
        if (this.walletSection) this.walletSection.style.display = 'none';
        return;
      }
    }

    // Convert to PublicKey object if it's a string
    let walletPublicKey;

    try {
      if (typeof window.AquaVaultsWallet.publicKey === 'string') {
        walletPublicKey = new window.solanaWeb3.PublicKey(window.AquaVaultsWallet.publicKey);
      } else if (window.AquaVaultsWallet.publicKey?.toBase58) {
        walletPublicKey = window.AquaVaultsWallet.publicKey;
      } else if (window.AquaVaultsWallet.publicKeyString) {
        walletPublicKey = new window.solanaWeb3.PublicKey(window.AquaVaultsWallet.publicKeyString);
      }

      if (!walletPublicKey) throw new Error('Failed to create PublicKey from wallet data');
    } catch (conversionError) {
      log('Error converting wallet publicKey:', conversionError?.message || conversionError, 'error');
      throw conversionError;
    }

    // 60-second cache: skip re-scan if we already have fresh wallet data
    if (
      this.walletTokensCache.length > 0 &&
      (Date.now() - this.walletTokensCacheTimestamp < 60_000)
    ) {
      if (this.walletSection) this.walletSection.style.display = 'block';
      this.displayWalletTokens(this.walletTokensCache);
      return;
    }

    if (this.walletSection) this.walletSection.style.display = 'block';

    if (this.walletResults) {
      this.walletResults.innerHTML = `
        <div class="token-picker-wallet-loading">
          Loading wallet tokens...
        </div>
      `;
    }

    try {
      // Reuse swapper's RPC connection if available (avoids extra /api/rpc fetch)
      let connection = window.AquaVaultsSwapper?._connection ?? null;
      if (!connection) {
        try {
          const rpcResponse = await fetch('/api/rpc');
          if (rpcResponse.ok) {
            const rpcData = await rpcResponse.json();
            connection = new window.solanaWeb3.Connection(rpcData.rpcUrl, 'processed');
          } else {
            connection = new window.solanaWeb3.Connection('https://api.mainnet-beta.solana.com');
          }
        } catch (rpcError) {
          log('Failed to fetch RPC URL, using public endpoint', 'warning');
          connection = new window.solanaWeb3.Connection('https://api.mainnet-beta.solana.com');
        }
      }

      // Fetch token accounts for BOTH programs (legacy + Token-2022)
      const TOKEN_PROGRAM_ID = new window.solanaWeb3.PublicKey(
        'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA'
      );
      const TOKEN_2022_PROGRAM_ID = new window.solanaWeb3.PublicKey(
        'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb'
      );

      const [tokenAccountsLegacy, tokenAccounts2022] = await Promise.all([
        connection.getParsedTokenAccountsByOwner(walletPublicKey, { programId: TOKEN_PROGRAM_ID }),
        connection.getParsedTokenAccountsByOwner(walletPublicKey, { programId: TOKEN_2022_PROGRAM_ID })
      ]);

      const allTokenAccounts = [
        ...(tokenAccountsLegacy?.value || []),
        ...(tokenAccounts2022?.value || [])
      ];

      // ── Pass 1: collect balances and identify unknown mints ──
      const walletEntries = []; // { mint, balance, decimals }
      const unknownMints = [];  // mints not in TokenRegistry

      for (const account of allTokenAccounts) {
        const parsedInfo = account.account.data.parsed.info;
        const balance = parsedInfo.tokenAmount.uiAmount;
        if (!balance || balance <= 0) continue;

        const mint = parsedInfo.mint;
        walletEntries.push({ mint, balance, decimals: parsedInfo.tokenAmount.decimals });

        const known = window.TokenRegistry ? window.TokenRegistry.get(mint) : null;
        if (!known) unknownMints.push(mint);
      }

      // Dedup unknown mints
      const dedupUnknownMints = [...new Set(unknownMints)];

      // ── Pass 2: enrich unknown mints (prefer TokenMetaCache → KV worker → fallback) ──
      const batchMeta = new Map();

      if (dedupUnknownMints.length > 0) {
        try {
          // Best path: TokenMetaCache (memory/localStorage + KV worker + safe fallbacks)
          if (window.TokenMetaCache && typeof window.TokenMetaCache.getBatchMintMeta === 'function') {
            const metaMap = await window.TokenMetaCache.getBatchMintMeta(dedupUnknownMints);
            // metaMap is expected to be a Map(mint -> normalizedMeta) or plain object; handle both.
            if (metaMap instanceof Map) {
              for (const [m, meta] of metaMap.entries()) batchMeta.set(m, meta);
            } else if (metaMap && typeof metaMap === 'object') {
              for (const [m, meta] of Object.entries(metaMap)) batchMeta.set(m, meta);
            }
          } else {
            // Next-best path: hit your KV-backed endpoint directly
            const mints = dedupUnknownMints.join(',');
            const res = await fetch(`/api/tokenmeta?mints=${encodeURIComponent(mints)}`);
            if (res.ok) {
              const data = await res.json();
              // Support { results: { mint: meta } } OR { mint: meta } maps.
              const mapObj = (data && data.results && typeof data.results === 'object') ? data.results : data;

              if (Array.isArray(mapObj)) {
                for (const t of mapObj) {
                  const m = t.address || t.id || t.mint;
                  if (m) batchMeta.set(m, t);
                }
              } else if (mapObj && typeof mapObj === 'object') {
                for (const [m, meta] of Object.entries(mapObj)) batchMeta.set(m, meta);
              }
            }
          }
        } catch (err) {
          log(
            'Token metadata enrichment failed, falling back to basic info: ' +
              (err?.message || String(err)),
            'warning'
          );
        }
      }

      // ── Pass 3: assemble wallet tokens with enriched metadata ──
      const walletTokens = [];

      for (const { mint, balance, decimals } of walletEntries) {
        let tokenInfo = window.TokenRegistry ? window.TokenRegistry.get(mint) : null;

        if (!tokenInfo) {
          const meta = batchMeta.get(mint);
          if (meta && !meta.notFound) {
            tokenInfo = {
              mint: meta.mint || meta.address || meta.id || mint,
              address: meta.address || meta.id || meta.mint || mint,
              symbol: meta.symbol || 'UNKNOWN',
              name: meta.name || 'Unknown Token',
              decimals: meta.decimals ?? decimals,
              logoURI: meta.icon || meta.logoURI || meta.logoURI || '',
              isVerified: meta.isVerified || meta.verified || false,
              tokenProgram: meta.tokenProgram || meta.token_program || null
            };

            // Persist to registry so future opens skip the batch entirely
            if (window.TokenRegistry) {
              try { window.TokenRegistry.addToken(tokenInfo); } catch (_) {}
            }
          }
        }

        if (!tokenInfo) {
          tokenInfo = {
            mint,
            address: mint,
            symbol: mint.slice(0, 4) + '...',
            name: 'Unknown Token',
            decimals,
            logoURI: '',
            isVerified: false
          };
        }

        walletTokens.push({ ...tokenInfo, balance });
      }

      this.walletTokensCache = walletTokens;
      this.walletTokensCacheTimestamp = Date.now();
      this.displayWalletTokens(walletTokens);
    } catch (err) {
      log('Error loading wallet tokens:', err, 'error');
      if (this.walletResults) {
        this.walletResults.innerHTML = `
          <div class="token-picker-wallet-empty">
            Failed to load wallet tokens${err?.message ? ': ' + err.message : ''}
          </div>
        `;
      }
    }
  }

  displayWalletTokens(tokens) {
    if (!this.walletResults) return;

    if (!tokens || tokens.length === 0) {
      this.walletResults.innerHTML = `
        <div class="token-picker-wallet-empty">
          No tokens found in wallet
        </div>
      `;
      return;
    }

    this.walletResults.innerHTML = tokens
      .map(token => {
        const safeSymbol = this._escapeHtml(token.symbol);
        const safeName = this._escapeHtml(token.name || '');
        const safeMint = this._escapeHtml(token.mint);
        const logoURI = this._sanitizeUrl(token.logoURI || '');
        const iconHTML = logoURI
          ? `<img src="${logoURI}" alt="${safeSymbol}"
                onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
             <div class="token-picker-result-icon-fallback" style="display:none;">${safeSymbol.charAt(0)}</div>`
          : `<div class="token-picker-result-icon-fallback">${safeSymbol.charAt(0)}</div>`;

        const verifiedBadge = token.isVerified
          ? '<span class="token-picker-badge token-picker-badge-verified">✓ Verified</span>'
          : '';

        const isToken2022 = (token.tokenProgram || token.token_program) === 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb';
        const token2022Badge = isToken2022
          ? '<span class="token-picker-badge token-picker-badge-token2022">Token-2022</span>'
          : '';

        const balanceFormatted = Number(token.balance || 0).toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 6
        });

        return `
          <div class="token-picker-result token-picker-wallet-token" data-mint="${safeMint}" style="margin-bottom: 0.5rem;">
            <div class="token-picker-result-icon">${iconHTML}</div>
            <div class="token-picker-result-info">
              <div class="token-picker-result-header">
                <span class="token-picker-result-symbol">${safeSymbol}</span>
                ${verifiedBadge}
                ${token2022Badge}
              </div>
              <div class="token-picker-result-name">${safeName}</div>
              <div class="token-picker-result-mint" style="margin-top: 0.25rem; color: #10b981;">
                Balance: ${balanceFormatted}
              </div>
            </div>
          </div>
        `;
      })
      .join('');

    // Wire click handlers for wallet tokens
    this.walletResults.querySelectorAll('.token-picker-wallet-token').forEach(el => {
      el.addEventListener('click', async () => {
        const mint = el.getAttribute('data-mint');
        const token = this.walletTokensCache.find(t => t.mint === mint);

        if (token) {
          // Add to registry if not already there
          const registryToken = window.TokenRegistry ? window.TokenRegistry.get(mint) : null;
          if (!registryToken) {
            try { window.TokenRegistry.addToken(token); } catch (_) {}
          }

          if (this.callback) {
            this.callback(window.TokenRegistry.get(mint));
            this.close();
          }
        }
      });
    });

    // Auto-expand if we have wallet tokens
    if (tokens.length > 0) {
      this.walletResults.classList.add('expanded');
      if (this.walletToggle) this.walletToggle.classList.add('expanded');
    }
  }

  // Get fallback icon URL from multiple sources
  getFallbackIconUrl(_mint) {
    // Keep this quiet: rely on Jupiter logoURI when available.
    // Returning '' means we use the letter fallback without extra network noise.
    return '';
  }
}

window.TokenPicker = new TokenPicker();

// Auto-init when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.TokenPicker.init());
} else {
  window.TokenPicker.init();
}
;
// Handles alternating forward/reverse swaps with Randomized configuration mode

// ============================================================
// LOGGING WRAPPER
// ============================================================

function log(...args) {
  const LEVELS = new Set(['info', 'success', 'silent-success', 'warning', 'error', 'pending']);

  let type = 'info';
  if (args.length > 1 && typeof args[args.length - 1] === 'string' && LEVELS.has(args[args.length - 1])) {
    type = args.pop();
  }

  const msg = args
    .map(v => {
      if (typeof v === 'string') return v;
      try { return JSON.stringify(v); } catch { return String(v); }
    })
    .join(' ');

  if (window.debugLog) window.debugLog(msg, type);
  else console.log(msg);
}

// ============================================================
// STATE
// ============================================================

let pendingReverses = []; // Queue of swaps waiting to be reversed
let flipFlopCancelled = false;
let balanceBefore = 0; // Track balance before swap for accurate received amount calculation

// ============================================================
// MINT TO SYMBOL MAPPING
// ============================================================

// Helper function to get MINT_TO_SYMBOL mapping
// Uses global MINT_TO_SYMBOL from autoswap-card.js if available
// Falls back to swapper.js or creates local mapping
function getMintSymbol(mint) {
  // Prefer TokenRegistry (covers custom tokens)
  if (window.TokenRegistry && typeof window.TokenRegistry.getSymbol === 'function') {
    try {
      const sym = window.TokenRegistry.getSymbol(mint);
      if (sym) return sym;
    } catch (_) {}
  }

  // Check if MINT_TO_SYMBOL is already defined globally
  if (typeof MINT_TO_SYMBOL !== 'undefined') {
    return MINT_TO_SYMBOL[mint];
  }
  
  // Fallback: use swapper.js mapping
  if (window.AquaVaultsSwapper && window.AquaVaultsSwapper.TOKEN_MINTS) {
    const mints = window.AquaVaultsSwapper.TOKEN_MINTS;
    // Create reverse mapping
    for (const [symbol, mintAddr] of Object.entries(mints)) {
      if (mintAddr === mint) return symbol;
    }
  }
  
  // Last resort: static mapping
  const staticMap = {
    "So11111111111111111111111111111111111111112": "SOL",
    "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v": "USDC",
    "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB": "USDT",
    "3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq": "wPOND",
    "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A": "hSOL",
    "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So": "mSOL",
    "B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B": "PepeOnSOL"
  };
  return staticMap[mint];
}

// ============================================================
// BALANCE POLL HELPER
// ============================================================

// Polls until balance changes from `before`, or times out after `timeoutMs`.
// Falls back to undefined if balance never moves (caller uses quote estimate).
async function pollBalanceChange(mint, before, { intervalMs = 2000, timeoutMs = 15000 } = {}) {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    await new Promise(r => setTimeout(r, intervalMs));
    try {
      const current = await window.AquaVaultsSwapper.getBalance(mint);
      if (current !== before) return current;
    } catch (_) {}
  }
  return undefined; // timed out — caller falls back to quote
}

// ============================================================
// CONDITION DETECTION
// ============================================================

function detectFlipFlopCondition(config) {
  const { useRandomPairs, useRandomAmount, pairs } = config;
  
  // Count configured pairs
  const configuredPairs = pairs.filter(p => p.from && p.to && p.from !== p.to);
  
  // If Random Pairs is ON but only 1 pair configured, ignore Random Pairs
  if (useRandomPairs && configuredPairs.length === 1) {
    log('Only 1 pair configured - ignoring Random Pairs toggle');
    return useRandomAmount ? 2 : 1; // Fall back to Condition 1 or 2
  }
  
  // Determine condition
  if (!useRandomPairs) {
    // Single pair mode
    return useRandomAmount ? 2 : 1;
  } else {
    // Random pairs mode
    // Check if ANY pair has random amount enabled
    const hasPerPairRandom = pairs.some(p => p.useRandom);
    return hasPerPairRandom || useRandomAmount ? 4 : 3;
  }
}

// ============================================================
// SHUFFLE UTILITIES
// ============================================================

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

function getShuffledPairs(pairs) {
  // Filter to only configured pairs
  const configured = pairs.filter(p => p.from && p.to && p.from !== p.to);
  // Completely shuffle all pairs (no special treatment for Pair 1)
  return shuffleArray(configured);
}

// ============================================================
// RANDOM AMOUNT GENERATION
// ============================================================

function getRandomAmount(min, max) {
  return parseFloat((Math.random() * (max - min) + min).toFixed(4));
}

function getPairAmount(pair, isForward, globalRandomAmount, globalMinAmount, globalMaxAmount) {
  if (!isForward) {
    // Reverse swap always uses exact received amount (set by caller)
    return pair.receivedAmount;
  }
  
  // Forward swap
  if (pair.index === 0 && globalRandomAmount) {
    // Pair 1 uses global random amount
    return getRandomAmount(globalMinAmount, globalMaxAmount);
  } else if (pair.useRandom) {
    // Pair has its own random amount
    return getRandomAmount(pair.minAmount, pair.maxAmount);
  } else {
    // Fixed amount
    return pair.amount;
  }
}

// ============================================================
// CONDITION 1: Single Pair, Fixed Amount
// ============================================================

async function executeCondition1(config, callbacks) {
  const { totalSwaps, pairs, slippageBps, platformFeeBps, priorityFeeLamports } = config;
  const pair = pairs[0];
  
  let swapCount = 0;
  let isForward = true;
  let lastReceivedAmount = 0;
  
  log(' Flip-Flop Condition 1: Single pair, fixed amount');
  
  while (swapCount < totalSwaps && !flipFlopCancelled) {
    swapCount++;
    
    let fromMint, toMint, amount;
    
    if (isForward) {
      // Forward swap
      fromMint = pair.from;
      toMint = pair.to;
      amount = pair.amount;
    } else {
      // Reverse swap - flip tokens and use received amount
      fromMint = pair.to;
      toMint = pair.from;
      amount = lastReceivedAmount;
    }
    
    const fromSymbol = getMintSymbol(fromMint);
    const toSymbol = getMintSymbol(toMint);
    const direction = isForward ? 'Forward' : 'Reverse';
    
    callbacks.onProgress(`Swap ${swapCount}/${totalSwaps}`, `${direction}: ${amount} ${fromSymbol} → → ${toSymbol}`);
    
    try {
      log(` ${direction} swap ${swapCount}/${totalSwaps}: ${amount} ${fromSymbol} → → ${toSymbol}`);
      
// Track balance before swap if forward
if (isForward) {
  try {
    balanceBefore = await window.AquaVaultsSwapper.getBalance(toMint);
  } catch (err) {
    log(`Warning: Could not get balance before swap: ${err.message}`, 'warning');
    balanceBefore = 0;
  }
}

      const result = await window.AquaVaultsSwapper.executeSwap(
        fromMint,
        toMint,
        parseFloat(amount),
        slippageBps,
        platformFeeBps,
        priorityFeeLamports
      );

      // Forward swaps: track received amount
      if (isForward) {
        const balanceAfter = await pollBalanceChange(toMint, balanceBefore);
        if (balanceAfter !== undefined) {
          lastReceivedAmount = balanceAfter - balanceBefore;
          log(`Forward swap received: ${lastReceivedAmount.toFixed(6)} ${toSymbol} (actual from balance)`, 'info');
        } else {
          log(`Warning: Balance did not change within timeout, falling back to quote estimate`, 'warning');
          const quote = await window.AquaVaultsSwapper.getSwapQuote(
            fromMint,
            toMint,
            parseFloat(amount),
            slippageBps,
            platformFeeBps
          );
          lastReceivedAmount = quote ? quote.estimatedOutput : 0;
          log(`Forward swap received: ${lastReceivedAmount} ${toSymbol} (estimate from quote)`, 'warning');
        }
      }

      callbacks.onSuccess(swapCount);
      log(`${direction} swap ${swapCount}/${totalSwaps} SUCCESS`, 'success');
      
    } catch (err) {
      callbacks.onFailure(swapCount, err);
      log(`${direction} swap ${swapCount}/${totalSwaps} FAILED: ${err.message}`, 'error');
    }
    
    // Toggle direction
    isForward = !isForward;
    
    // Wait before next swap (if not last)
    if (swapCount < totalSwaps && !flipFlopCancelled) {
      await callbacks.onWait(config, swapCount);
    }
  }
}

// ============================================================
// CONDITION 2: Single Pair, Random Amount
// ============================================================

async function executeCondition2(config, callbacks) {
  const { totalSwaps, pairs, slippageBps, platformFeeBps, priorityFeeLamports, minRandomAmount, maxRandomAmount } = config;
  const pair = pairs[0];
  
  let swapCount = 0;
  let isForward = true;
  let lastReceivedAmount = 0;
  let currentCycleAmount = 0;
  
  log(' Flip-Flop Condition 2: Single pair, random amount per cycle');
  
  while (swapCount < totalSwaps && !flipFlopCancelled) {
    swapCount++;
    
    let fromMint, toMint, amount;
    
    if (isForward) {
      // Forward swap - generate NEW random amount
      currentCycleAmount = getRandomAmount(minRandomAmount, maxRandomAmount);
      fromMint = pair.from;
      toMint = pair.to;
      amount = currentCycleAmount;
      log(`New cycle random amount: ${amount}`);
    } else {
      // Reverse swap - flip tokens and use received amount
      fromMint = pair.to;
      toMint = pair.from;
      amount = lastReceivedAmount;
    }
    
    const fromSymbol = getMintSymbol(fromMint);
    const toSymbol = getMintSymbol(toMint);
    const direction = isForward ? 'Forward' : 'Reverse';
    
    callbacks.onProgress(`Swap ${swapCount}/${totalSwaps}`, `${direction}: ${amount} ${fromSymbol} → → ${toSymbol}`);
    
    try {
      log(` ${direction} swap ${swapCount}/${totalSwaps}: ${amount} ${fromSymbol} → → ${toSymbol}`);
      
      // Track balance before swap if forward
      if (isForward) {
        try {
          balanceBefore = await window.AquaVaultsSwapper.getBalance(toMint);
        } catch (err) {
          log(`Warning: Could not get balance before swap: ${err.message}`, 'warning');
          balanceBefore = 0;
        }
      }
      
      const result = await window.AquaVaultsSwapper.executeSwap(
        fromMint,
        toMint,
        parseFloat(amount),
        slippageBps,
        platformFeeBps,
        priorityFeeLamports
      );
      
      if (isForward) {
        const balanceAfter = await pollBalanceChange(toMint, balanceBefore);
        if (balanceAfter !== undefined) {
          lastReceivedAmount = balanceAfter - balanceBefore;
          log(`Forward swap received: ${lastReceivedAmount.toFixed(6)} ${toSymbol} (actual from balance)`, 'info');
        } else {
          log(`Warning: Balance did not change within timeout, falling back to quote estimate`, 'warning');
          const quote = await window.AquaVaultsSwapper.getSwapQuote(
            fromMint,
            toMint,
            parseFloat(amount),
            slippageBps,
            platformFeeBps
          );
          lastReceivedAmount = quote ? quote.estimatedOutput : 0;
          log(`Forward swap received: ${lastReceivedAmount} ${toSymbol} (estimate from quote)`, 'warning');
        }
      }
      
      callbacks.onSuccess(swapCount);
      log(`${direction} swap ${swapCount}/${totalSwaps} SUCCESS`, 'success');
      
    } catch (err) {
      callbacks.onFailure(swapCount, err);
      log(`${direction} swap ${swapCount}/${totalSwaps} FAILED: ${err.message}`, 'error');
    }
    
    isForward = !isForward;
    
    if (swapCount < totalSwaps && !flipFlopCancelled) {
      await callbacks.onWait(config, swapCount);
    }
  }
}

// ============================================================
// CONDITION 3: Random Pairs, All Fixed Amounts
// ============================================================

async function executeCondition3(config, callbacks) {
  const { totalSwaps, pairs, slippageBps, platformFeeBps, priorityFeeLamports } = config;
  
  let swapCount = 0;
  pendingReverses = [];
  
  log(' Flip-Flop Condition 3: Random pairs, all fixed amounts, Randomized configuration mode');
  
  while (swapCount < totalSwaps && !flipFlopCancelled) {
    // FORWARD PHASE - Shuffle all pairs
    const shuffledPairs = getShuffledPairs(pairs);
    log(`New cycle shuffle: ${shuffledPairs.map((p, i) => `Pair ${p.index + 1}`).join(' → → ')}`);
    
    for (const pair of shuffledPairs) {
      if (swapCount >= totalSwaps || flipFlopCancelled) break;
      swapCount++;
      
      const fromMint = pair.from;
      const toMint = pair.to;

      const fromSymbol = getMintSymbol(fromMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(fromMint) : fromMint.slice(0, 4) + '...');
      const toSymbol = getMintSymbol(toMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(toMint) : toMint.slice(0, 4) + '...');

      const amount = pair.amount;
      
      callbacks.onProgress(`Swap ${swapCount}/${totalSwaps}`, `Forward: ${amount} ${fromSymbol} → → ${toSymbol}`);
      
      try {
        log(` Forward swap ${swapCount}/${totalSwaps}: ${amount} ${fromSymbol} → → ${toSymbol}`);
        
        // Track balance before swap
        let balanceBefore = 0;
        try {
          balanceBefore = await window.AquaVaultsSwapper.getBalance(toMint);
        } catch (err) {
          log(`Warning: Could not get balance before swap: ${err.message}`, 'warning');
        }
        
        const result = await window.AquaVaultsSwapper.executeSwap(
          fromMint,
          toMint,
          parseFloat(amount),
          slippageBps,
          platformFeeBps,
          priorityFeeLamports
        );
        
        // Get actual received amount from balance change
        let receivedAmount = 0;
        const balanceAfter3 = await pollBalanceChange(toMint, balanceBefore);
        if (balanceAfter3 !== undefined) {
          receivedAmount = balanceAfter3 - balanceBefore;
          log(`Forward received ${receivedAmount.toFixed(6)} ${toSymbol} (actual from balance)`, 'success');
        } else {
          log(`Warning: Balance did not change within timeout, falling back to quote estimate`, 'warning');
          const quote = await window.AquaVaultsSwapper.getSwapQuote(
            fromMint,
            toMint,
            parseFloat(amount),
            slippageBps,
            platformFeeBps
          );
          receivedAmount = quote ? quote.estimatedOutput : 0;
          log(`Forward received ${receivedAmount} ${toSymbol} (estimate from quote)`, 'warning');
        }
        
        // Add to pending queue
        pendingReverses.push({
          from: pair.to,
          to: pair.from,
          amount: receivedAmount,
          originalSwapIndex: swapCount
        });
        
        log(`Forward received ${receivedAmount} ${toSymbol} - added to pending queue`);
        callbacks.onSuccess(swapCount);
        
      } catch (err) {
        callbacks.onFailure(swapCount, err);
        log(`Forward swap ${swapCount}/${totalSwaps} FAILED: ${err.message}`, 'error');
      }
      
      if (swapCount < totalSwaps && !flipFlopCancelled) {
        await callbacks.onWait(config, swapCount);
      }
    }
    
    // REVERSE PHASE - Random order from pending queue
    const shuffledReverses = shuffleArray(pendingReverses);
    log(`Reverse phase shuffle: ${shuffledReverses.map(r => `Swap ${r.originalSwapIndex}`).join(' → → ')}`);
    
    for (const reverse of shuffledReverses) {
      if (swapCount >= totalSwaps || flipFlopCancelled) break;
      swapCount++;
      
      const fromMint = reverse.from;
      const toMint = reverse.to;

      const fromSymbol = getMintSymbol(fromMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(fromMint) : fromMint.slice(0, 4) + '...');
      const toSymbol = getMintSymbol(toMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(toMint) : toMint.slice(0, 4) + '...');

      const amount = reverse.amount;
      
      callbacks.onProgress(`Swap ${swapCount}/${totalSwaps}`, `Reverse: ${amount} ${fromSymbol} → → ${toSymbol}`);
      
      try {
        log(` Reverse swap ${swapCount}/${totalSwaps}: ${amount} ${fromSymbol} → → ${toSymbol} (from swap ${reverse.originalSwapIndex})`);
        
        const result = await window.AquaVaultsSwapper.executeSwap(
          fromMint,
          toMint,
          parseFloat(amount),
          slippageBps,
          platformFeeBps,
          priorityFeeLamports
        );
        
        callbacks.onSuccess(swapCount);
        log(`Reverse swap ${swapCount}/${totalSwaps} SUCCESS`, 'success');
        
      } catch (err) {
        callbacks.onFailure(swapCount, err);
        log(`Reverse swap ${swapCount}/${totalSwaps} FAILED: ${err.message}`, 'error');
      }
      
      if (swapCount < totalSwaps && !flipFlopCancelled) {
        await callbacks.onWait(config, swapCount);
      }
    }
    
    // Clear pending queue for next cycle
    pendingReverses = [];
  }
  
  // If stopped mid-cycle, abandon pending reverses
  if (flipFlopCancelled && pendingReverses.length > 0) {
    log(`Stopped mid-cycle - abandoning ${pendingReverses.length} pending reverses`);
    pendingReverses = [];
  }
}

// ============================================================
// CONDITION 4: Random Pairs, Some/All Random Amounts
// ============================================================

async function executeCondition4(config, callbacks) {
  const { totalSwaps, pairs, slippageBps, platformFeeBps, priorityFeeLamports, useRandomAmount, minRandomAmount, maxRandomAmount } = config;
  
  let swapCount = 0;
  pendingReverses = [];
  
  log(' Flip-Flop Condition 4: Random pairs with per-pair random amounts, Randomized configuration mode');
  
  while (swapCount < totalSwaps && !flipFlopCancelled) {
    // FORWARD PHASE - Shuffle all pairs
    const shuffledPairs = getShuffledPairs(pairs);
    log(`New cycle shuffle: ${shuffledPairs.map((p, i) => `Pair ${p.index + 1}`).join(' → → ')}`);
    
    for (const pair of shuffledPairs) {
      if (swapCount >= totalSwaps || flipFlopCancelled) break;
      swapCount++;
      
      // Determine amount (random or fixed)
      let amount;
      if (pair.index === 0 && useRandomAmount) {
        // Pair 1 uses global random amount
        amount = getRandomAmount(minRandomAmount, maxRandomAmount);
        log(`Pair 1 random amount: ${amount}`);
      } else if (pair.useRandom) {
        // Pair has its own random amount
        amount = getRandomAmount(pair.minAmount, pair.maxAmount);
        log(`Pair ${pair.index + 1} random amount: ${amount}`);
      } else {
        // Fixed amount
        amount = pair.amount;
      }
      
      const fromMint = pair.from;
      const toMint = pair.to;

      const fromSymbol = getMintSymbol(fromMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(fromMint) : fromMint.slice(0, 4) + '...');
      const toSymbol = getMintSymbol(toMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(toMint) : toMint.slice(0, 4) + '...');
      
      callbacks.onProgress(`Swap ${swapCount}/${totalSwaps}`, `Forward: ${amount} ${fromSymbol} → → ${toSymbol}`);
      
      try {
        log(` Forward swap ${swapCount}/${totalSwaps}: ${amount} ${fromSymbol} → → ${toSymbol}`);
        
        // Track balance before swap
        let balanceBefore = 0;
        try {
          balanceBefore = await window.AquaVaultsSwapper.getBalance(toMint);
        } catch (err) {
          log(`Warning: Could not get balance before swap: ${err.message}`, 'warning');
        }
        
        const result = await window.AquaVaultsSwapper.executeSwap(
          fromMint,
          toMint,
          parseFloat(amount),
          slippageBps,
          platformFeeBps,
          priorityFeeLamports
        );
        
        // Get actual received amount from balance change
        let receivedAmount = 0;
        const balanceAfter4 = await pollBalanceChange(toMint, balanceBefore);
        if (balanceAfter4 !== undefined) {
          receivedAmount = balanceAfter4 - balanceBefore;
          log(`Forward received ${receivedAmount.toFixed(6)} ${toSymbol} (actual from balance)`, 'success');
        } else {
          log(`Warning: Balance did not change within timeout, falling back to quote estimate`, 'warning');
          const quote = await window.AquaVaultsSwapper.getSwapQuote(
            fromMint,
            toMint,
            parseFloat(amount),
            slippageBps,
            platformFeeBps
          );
          receivedAmount = quote ? quote.estimatedOutput : 0;
          log(`Forward received ${receivedAmount} ${toSymbol} (estimate from quote)`, 'warning');
        }
        
        // Add to pending queue
        pendingReverses.push({
          from: pair.to,
          to: pair.from,
          amount: receivedAmount,
          originalSwapIndex: swapCount
        });
        
        log(`Forward received ${receivedAmount} ${toSymbol} - added to pending queue`);
        callbacks.onSuccess(swapCount);
        
      } catch (err) {
        callbacks.onFailure(swapCount, err);
        log(`Forward swap ${swapCount}/${totalSwaps} FAILED: ${err.message}`, 'error');
      }
      
      if (swapCount < totalSwaps && !flipFlopCancelled) {
        await callbacks.onWait(config, swapCount);
      }
    }
    
    // REVERSE PHASE - Random order from pending queue
    const shuffledReverses = shuffleArray(pendingReverses);
    log(`Reverse phase shuffle: ${shuffledReverses.map(r => `Swap ${r.originalSwapIndex}`).join(' → → ')}`);
    
    for (const reverse of shuffledReverses) {
      if (swapCount >= totalSwaps || flipFlopCancelled) break;
      swapCount++;
      
      const fromMint = reverse.from;
      const toMint = reverse.to;

      const fromSymbol = getMintSymbol(fromMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(fromMint) : fromMint.slice(0, 4) + '...');
      const toSymbol = getMintSymbol(toMint) || (window.TokenRegistry?.getSymbol ? window.TokenRegistry.getSymbol(toMint) : toMint.slice(0, 4) + '...');

      const amount = reverse.amount;
      
      callbacks.onProgress(`Swap ${swapCount}/${totalSwaps}`, `Reverse: ${amount} ${fromSymbol} → → ${toSymbol}`);
      
      try {
        log(` Reverse swap ${swapCount}/${totalSwaps}: ${amount} ${fromSymbol} → → ${toSymbol} (from swap ${reverse.originalSwapIndex})`);
        
        const result = await window.AquaVaultsSwapper.executeSwap(
          fromMint,
          toMint,
          parseFloat(amount),
          slippageBps,
          platformFeeBps,
          priorityFeeLamports
        );
        
        callbacks.onSuccess(swapCount);
        log(`Reverse swap ${swapCount}/${totalSwaps} SUCCESS`, 'success');
        
      } catch (err) {
        callbacks.onFailure(swapCount, err);
        log(`Reverse swap ${swapCount}/${totalSwaps} FAILED: ${err.message}`, 'error');
      }
      
      if (swapCount < totalSwaps && !flipFlopCancelled) {
        await callbacks.onWait(config, swapCount);
      }
    }
    
    // Clear pending queue for next cycle
    pendingReverses = [];
  }
  
  // If stopped mid-cycle, abandon pending reverses
  if (flipFlopCancelled && pendingReverses.length > 0) {
    log(`Stopped mid-cycle - abandoning ${pendingReverses.length} pending reverses`);
    pendingReverses = [];
  }
}

// ============================================================
// MAIN EXECUTION
// ============================================================

async function executeFlipFlop(config, callbacks) {
  flipFlopCancelled = false;
  pendingReverses = [];
  
  const condition = detectFlipFlopCondition(config);
  
  // Only log randomization features if they're ON
  if (config.useRandomWait) {
    log('Random Wait: ' + config.minWaitTime + '-' + config.maxWaitTime + 's', 'info');
  }
  if (config.useRandomAmount) {
    log('Random Amount: ' + config.minRandomAmount + '-' + config.maxRandomAmount, 'info');
  }
  if (config.useRandomPairs) {
    log('Random Pairs: ' + config.pairs.length + ' pairs', 'info');
  }
  
  switch (condition) {
    case 1:
      await executeCondition1(config, callbacks);
      break;
    case 2:
      await executeCondition2(config, callbacks);
      break;
    case 3:
      await executeCondition3(config, callbacks);
      break;
    case 4:
      await executeCondition4(config, callbacks);
      break;
    default:
      log('Unknown flip-flop condition', 'error');
  }
}

function cancelFlipFlop() {
  flipFlopCancelled = true;
  pendingReverses = [];
}

// ============================================================
// EXPORTS
// ============================================================

window.FlipFlopEngine = {
  execute: executeFlipFlop,
  cancel: cancelFlipFlop,
  detectCondition: detectFlipFlopCondition
};

;
/**
 * autoswap-card.js
 *
 * Bundles the inline helpers + Auto Swap controller that used to live inside autoswap-card-wired.html.
 *
 * Requirements (loaded BEFORE this file):
 *   - swapper.js (defines window.AquaVaultsSwapper + swap functions)
 *   - flipflop.js (defines window.FlipFlopEngine used by autoswap.js)
 *
 * This file also polyfills Buffer if needed (for some Solana libs).
 */

// ============================================================
// LOGGING WRAPPER
// ============================================================

function log(...args) {
  const LEVELS = new Set(['info', 'success', 'silent-success', 'warning', 'error', 'pending']);

  let type = 'info';
  if (args.length > 1 && typeof args[args.length - 1] === 'string' && LEVELS.has(args[args.length - 1])) {
    type = args.pop();
  }

  const msg = args
    .map(v => {
      if (typeof v === 'string') return v;
      try { return JSON.stringify(v); } catch { return String(v); }
    })
    .join(' ');

  if (window.debugLog) window.debugLog(msg, type);
  else console.log(msg);
}

// ============================================================
// CONSTRAINTS TOGGLE (needs to be defined early)
// ============================================================
window.toggleConstraints = function() {
  const container = document.getElementById('constraintsContainer');
  if (!container) {
    log('constraintsContainer not found');
    return;
  }
  
  const wasExpanded = container.classList.contains('expanded');
  container.classList.toggle('expanded');
  
    // Save expanded state to localStorage
  localStorage.setItem('swapSettingsExpanded', container.classList.contains('expanded'));
};

// ============================================================
// SETTINGS PERSISTENCE FUNCTIONS (needs to be defined early)
// ============================================================
window.updateFeeDisplay = function() {
  const input = document.getElementById('feeInput');
  let value = parseFloat(input.value) || 0;
  
  // Round to 1 decimal place
  value = Math.round(value * 10) / 10;
  input.value = value;
  
  const percent = value.toFixed(1) + '%';
  const preview = document.getElementById('feePreview');
  if (preview) preview.textContent = percent;
  
  // Convert to bps for storage (1% = 100 bps)
  const bps = Math.round(value * 100);
  localStorage.setItem('platformFeeBps', bps);
};

window.updateSlippageDisplay = function() {
  const input = document.getElementById('slippageInput');
  let value = parseFloat(input.value) || 0;
  
  // Round to 1 decimal place
  value = Math.round(value * 10) / 10;
  input.value = value;
  
  const percent = value.toFixed(1) + '%';
  const preview = document.getElementById('slippagePreview');
  if (preview) preview.textContent = percent;
  
  // Convert to bps for storage (1% = 100 bps)
  const bps = Math.round(value * 100);
  localStorage.setItem('slippageBps', bps);
};

window.updatePriorityDisplay = function() {
  const select = document.getElementById('prioritySelect');
  const customContainer = document.getElementById('customPriorityContainer');
  const customInput = document.getElementById('customPriorityInput');
  
  if (!select) return;
  
  const selectedValue = select.value;
  
  // Show/hide custom input
  if (selectedValue === 'custom') {
    if (customContainer) customContainer.style.display = 'block';
    const customSol = parseFloat(customInput?.value || 0.0001);
    const customLamports = Math.floor(customSol * 1000000000);
    const display = customSol.toFixed(5) + ' SOL';
    const preview = document.getElementById('priorityPreview');
    if (preview) preview.textContent = display;
    localStorage.setItem('priorityFeeLamports', customLamports);
  } else {
    if (customContainer) customContainer.style.display = 'none';
    const lamports = parseInt(selectedValue) || 0;
    let display;
    if (lamports === 0) {
      display = 'Auto';
    } else {
      const sol = lamports / 1000000000;
      display = sol.toFixed(5) + ' SOL';
    }
    const preview = document.getElementById('priorityPreview');
    if (preview) preview.textContent = display;
    localStorage.setItem('priorityFeeLamports', lamports);
  }
};

window.adjustFee = function(delta) {
  const input = document.getElementById('feeInput');
  let value = parseFloat(input.value) || 0;
  value = Math.round((value + delta) * 10) / 10; // Round to 1 decimal
  value = Math.max(0, Math.min(10, value)); // 0% to 10%
  input.value = value;
  window.updateFeeDisplay();
};

window.adjustSlippage = function(delta) {
  const input = document.getElementById('slippageInput');
  let value = parseFloat(input.value) || 0;
  value = Math.round((value + delta) * 10) / 10; // Round to 1 decimal
  value = Math.max(0, Math.min(50, value)); // 0% to 50%
  input.value = value;
  window.updateSlippageDisplay();
};

window.adjustPriority = function(delta) {
  // This function is no longer used with dropdown, but keeping for compatibility
  return;
};

// ============================================================
// TOOLTIP UX FIXES (autoswap-card.js)
// - Desktop: tooltip opens below the icon (cursor not in the middle)
// - Mobile: tap anywhere (including the tooltip) to dismiss
// - Prevent "stuck hover" tooltips on touch devices
// ============================================================
(function initTooltipUX_AutoSwap() {
  // Optional CSS helper (won't break if your autoswap uses different tooltip element names)
  if (!document.getElementById('av-tooltip-ux-fix-asw')) {
    const style = document.createElement('style');
    style.id = 'av-tooltip-ux-fix-asw';
    style.textContent = `
      /* Touch devices: disable hover-to-show to prevent sticky hover */
      @media (hover:none), (pointer:coarse){
        .asw-hint-holder:hover .asw-hint-tooltip,
        .asw-hint-holder:hover .tooltip{
          display:none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function closeAllTooltips() {
    document.querySelectorAll('.asw-hint-holder.active').forEach(el => {
      el.classList.remove('active');
    });
  }

  window.toggleTooltip = function(event, containerId) {
    if (event?.preventDefault) event.preventDefault();
    if (event?.stopPropagation) event.stopPropagation();

    const container = document.getElementById(containerId);
    if (!container) return;

    const wasActive = container.classList.contains('active');
    closeAllTooltips();
    if (!wasActive) container.classList.add('active');
  };

  // Tap/click anywhere else (or on tooltip itself) closes
  document.addEventListener(
    'pointerdown',
    function(event) {
      // allow tapping the info icon without instantly closing
      if (event.target?.closest?.('.info-icon, .asw-info-icon')) return;
      closeAllTooltips();
    },
    { capture: true }
  );

  // Escape closes (desktop)
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeAllTooltips();
  });
})();


// ============================================================
// AFFILIATE SELECTOR FUNCTIONS (matching swap-card exactly)
// ============================================================

// ============================================================
// COMMUNITY SELECTOR
// ============================================================

let selectedCommunityId = null;

function getStoredCommunityId() {
  const raw = localStorage.getItem('selectedCommunity');
  if (raw && window.CommunityRegistry && window.CommunityRegistry.has(raw)) {
    return raw;
  }
  return 'aquavaults';
}

function initCommunityDropdown(retries = 5) {
  if (!window.CommunityRegistry) {
    if (retries > 0) {
      setTimeout(() => initCommunityDropdown(retries - 1), 200);
    } else {
      console.error('CommunityRegistry not loaded after retries');
    }
    return;
  }

  selectedCommunityId = getStoredCommunityId();
  localStorage.setItem('selectedCommunity', selectedCommunityId);

  populateCommunityDropdown();
  updateSelectedCommunityDisplay(selectedCommunityId);
  updateVaultDisplay();

  if (!document.body.dataset.communityDropdownBoundAutoSwap) {
    document.addEventListener('click', (e) => {
      const dropdown = document.getElementById('communityDropdown');
      const selector = document.getElementById('communitySelector');
      if (dropdown && selector && !selector.contains(e.target)) {
        dropdown.classList.remove('open');
        selector.classList.remove('open');
      }
    });
    document.body.dataset.communityDropdownBoundAutoSwap = '1';
  }
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = String(text ?? '');
  return div.innerHTML;
}

function populateCommunityDropdown() {
  const dropdown = document.getElementById('communityDropdown');
  if (!dropdown) return;

  dropdown.innerHTML = '';
  const communities = window.CommunityRegistry.getAll();

  communities.forEach(community => {
    const item = document.createElement('div');
    item.className = 'community-dropdown-item';
    item.onclick = (e) => {
      e.stopPropagation();
      selectCommunity(community.id);
    };

    item.innerHTML = `
      <img src="${community.logo}" alt="${community.name}" class="community-dropdown-logo" />
      <span class="community-dropdown-name">${community.name}</span>
    `;

    dropdown.appendChild(item);
  });
}

function toggleCommunityDropdown() {
  const dropdown = document.getElementById('communityDropdown');
  const selector = document.getElementById('communitySelector');
  
  if (!dropdown || !selector) return;

  const isOpen = dropdown.classList.toggle('open');
  selector.classList.toggle('open', isOpen);
}

function selectCommunity(communityId) {
  if (!window.CommunityRegistry || !window.CommunityRegistry.has(communityId)) {
    return;
  }

  selectedCommunityId = communityId;
  localStorage.setItem('selectedCommunity', communityId);

  updateSelectedCommunityDisplay(communityId);
  updateVaultDisplay();

  const dropdown = document.getElementById('communityDropdown');
  const selector = document.getElementById('communitySelector');
  if (dropdown && selector) {
    dropdown.classList.remove('open');
    selector.classList.remove('open');
  }

  log(`Community selected: ${communityId}`, 'info');
}

function updateSelectedCommunityDisplay(communityId) {
  const selectedDiv = document.getElementById('communitySelected');
  if (!selectedDiv || !window.CommunityRegistry) return;

  const community = window.CommunityRegistry.get(communityId);
  if (!community) {
    selectedDiv.innerHTML = '';
    return;
  }

  selectedDiv.innerHTML = `
    <div class="community-selected-content">
      <img src="${community.logo}" alt="${community.name}" class="community-selected-logo" />
      <div class="community-selected-info">
        <span class="community-selected-name">${community.name}</span>
        <a href="/community-affiliates#community-${communityId}" class="community-selected-link" onclick="event.stopPropagation()">View Details</a>
      </div>
    </div>
  `;
}

window.toggleCommunityDropdown = toggleCommunityDropdown;
window.selectCommunity = selectCommunity;

// ============================================================
// TOKEN PICKER INTEGRATION
// ============================================================

// Handle token dropdown changes (detect custom token selection)
window.handlePairTokenChange = function(dropdownId) {
  const dropdown = document.getElementById(dropdownId);
  if (!dropdown) return;
  
  // Check if user selected "Search / Custom..."
  if (dropdown.value === '__custom__') {
    const lastValue = dropdown.getAttribute('data-last-value');
    dropdown.value = lastValue || (dropdown.id.includes('From') ? 'So11111111111111111111111111111111111111112' : 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v');
    openTokenPicker(dropdownId);
    return;
  }
  
  // Store last valid value
  dropdown.setAttribute('data-last-value', dropdown.value);
  
  // Update vault display if this is pair1From
  if (dropdownId === 'pair1From') {
    updateVaultDisplay();
  }
  
  // Update balance for the changed pair
  updatePairBalance(dropdownId);
};

// Open token picker modal
function openTokenPicker(dropdownId) {
  if (!window.TokenPicker) {
    alert('Token picker not loaded');
    return;
  }
  
  window.TokenPicker.open((selectedToken) => {
    addCustomTokenToDropdown(dropdownId, selectedToken);
  });
}

// Add custom token to dropdown and select it
function addCustomTokenToDropdown(dropdownId, token) {
  const dropdown = document.getElementById(dropdownId);
  if (!dropdown) return;
  
  // Check if token already exists in dropdown
  let existingOption = null;
  for (let i = 0; i < dropdown.options.length; i++) {
    if (dropdown.options[i].value === token.mint) {
      existingOption = dropdown.options[i];
      break;
    }
  }
  
  if (existingOption) {
    // Token already in dropdown, just select it
    dropdown.value = token.mint;
  } else {
    // Add new option before the "Search / Custom..." option
    const newOption = document.createElement('option');
    newOption.value = token.mint;
    
    // Add icon as data attribute for potential CSS styling
    if (token.logoURI) {
      newOption.setAttribute('data-icon', token.logoURI);
    }
    
    newOption.textContent = token.symbol + (token.isVerified ? ' ✓' : '');
    
    // Insert before the __custom__ option
    const customOption = dropdown.querySelector('option[value="__custom__"]');
    if (customOption) {
      dropdown.insertBefore(newOption, customOption);
    } else {
      dropdown.appendChild(newOption);
    }
    
    dropdown.value = token.mint;
  }
  
  // Also add to all OTHER pair dropdowns so the token is available everywhere
  const allDropdowns = ['pair1From', 'pair1To', 'pair2From', 'pair2To'];
  allDropdowns.forEach(function(id) {
    if (id === dropdownId) return;
    const otherSelect = document.getElementById(id);
    if (!otherSelect) return;
    let alreadyExists = false;
    for (let i = 0; i < otherSelect.options.length; i++) {
      if (otherSelect.options[i].value === token.mint) {
        alreadyExists = true;
        break;
      }
    }
    if (!alreadyExists) {
      const otherOption = document.createElement('option');
      otherOption.value = token.mint;
      otherOption.textContent = token.symbol + (token.isVerified ? ' ✓' : '');
      const otherCustomOption = otherSelect.querySelector('option[value="__custom__"]');
      if (otherCustomOption) {
        otherSelect.insertBefore(otherOption, otherCustomOption);
      } else {
        otherSelect.appendChild(otherOption);
      }
    }
  });

  // Trigger change event
  dropdown.setAttribute('data-last-value', token.mint);
  
  // Update vault display if this is pair1From
  if (dropdownId === 'pair1From') {
    updateVaultDisplay();
  }
  
  log(`Added custom token to ${dropdownId} dropdown: ${token.symbol}`, 'success');
}

// ============================================================
// BALANCE DISPLAY FUNCTIONS
// ============================================================

// Update balance for a specific pair
async function updatePairBalance(dropdownId) {
  // Balance display ID is derived directly from dropdown ID (e.g. pair1From → pair1FromBalance)
  const balanceDisplay = document.getElementById(`${dropdownId}Balance`);
  if (!balanceDisplay) return;
  
  // Check if wallet is connected
  const headerState = window.AquaVaultsHeader ? window.AquaVaultsHeader.getWalletState() : { connected: false };
  const swapperConnected = window.AquaVaultsSwapper ? window.AquaVaultsSwapper.isConnected() : false;
  
  if (!headerState.connected || !swapperConnected) {
    balanceDisplay.innerHTML = 'Balance: <em>—</em>';
    return;
  }
  
  // Get the token mint from the dropdown directly
  const dropdown = document.getElementById(dropdownId);
  if (!dropdown || !dropdown.value || dropdown.value === '') {
    balanceDisplay.innerHTML = 'Balance: <em>—</em>';
    return;
  }
  
  const tokenMint = dropdown.value;
  
  // Get symbol from registry
  const tokenSymbol = window.TokenRegistry ? window.TokenRegistry.getSymbol(tokenMint) : tokenMint.slice(0, 4) + '...';
  
  balanceDisplay.innerHTML = 'Balance: <em>Loading...</em>';
  
  try {
    const balance = await window.AquaVaultsSwapper.getBalance(tokenMint);
    balanceDisplay.innerHTML = `Balance: <strong>${balance.toFixed(4)}</strong> ${tokenSymbol}`;
  } catch (err) {
    log('Error updating balance for ' + dropdownId + ':', err);
    balanceDisplay.innerHTML = 'Balance: <em style="color:#ef4444;">Error</em>';
  }
}

// Update all pair balances (From and To)
async function updateAllBalances() {
  await updatePairBalance('pair1From');
  await updatePairBalance('pair1To');
  await updatePairBalance('pair2From');
  await updatePairBalance('pair2To');
  await updatePairBalance('pair3From');
  await updatePairBalance('pair3To');
}

// Populate all dropdowns with saved custom tokens
function populateCustomTokensInAllDropdowns() {
  if (!window.TokenRegistry) return;
  
  const customs = window.TokenRegistry.getCustoms();
  if (customs.length === 0) return;
  
  const dropdownIds = ['pair1From', 'pair1To', 'pair2From', 'pair2To', 'pair3From', 'pair3To'];
  
  dropdownIds.forEach(dropdownId => {
    const dropdown = document.getElementById(dropdownId);
    if (!dropdown) return;
    
    customs.forEach(token => {
      // Check if already exists
      let exists = false;
      for (let i = 0; i < dropdown.options.length; i++) {
        if (dropdown.options[i].value === token.mint) {
          exists = true;
          break;
        }
      }
      
      if (!exists) {
        const option = document.createElement('option');
        option.value = token.mint;
        
        // Add icon as data attribute
        if (token.logoURI) {
          option.setAttribute('data-icon', token.logoURI);
        }
        
        option.textContent = token.symbol + (token.isVerified ? ' ✓' : '');
        
        const customOption = dropdown.querySelector('option[value="__custom__"]');
        if (customOption) {
          dropdown.insertBefore(option, customOption);
        } else {
          dropdown.appendChild(option);
        }
      }
    });
  });
}

function updateVaultDisplay() {
  const vaultPill = document.getElementById('vaultPill');
  const pair1From = document.getElementById('pair1From');
  
  if (!vaultPill || !pair1From) return;
  
  if (!window.CommunityRegistry) {
    vaultPill.innerHTML = `<span>Loading community...</span>`;
    vaultPill.style.background = 'rgba(99, 102, 241, 0.15)';
    vaultPill.style.borderColor = 'rgba(99, 102, 241, 0.3)';
    vaultPill.style.color = '#818cf8';
    return;
  }

  if (!selectedCommunityId || !window.CommunityRegistry.has(selectedCommunityId)) {
    selectedCommunityId = 'aquavaults';
    localStorage.setItem('selectedCommunity', selectedCommunityId);
  }

  const community = window.CommunityRegistry.get(selectedCommunityId);
  if (!community) return;

  const tokenMint = pair1From.value;
  const tokenSymbol = window.TokenRegistry ? window.TokenRegistry.getSymbol(tokenMint) : tokenMint.slice(0, 4) + '...';
  
  const hasVault = window.CommunityRegistry.hasTokenVault(selectedCommunityId, tokenMint);
  const destination = window.CommunityRegistry.getFeeDestination(selectedCommunityId, tokenMint);
  
  const safeTokenSymbol = escapeHtml(tokenSymbol);
  const safeCommunityName = escapeHtml(community.name);
  const safeDestination = escapeHtml(destination);

  if (hasVault) {
    vaultPill.innerHTML = `<div class="vault-pill-header"><img src="${community.logo}" alt="${safeCommunityName}" class="vault-logo" /><span>${safeTokenSymbol} Vault (${safeCommunityName}):</span></div><div class="vault-pill-address">${safeDestination}</div>`;
    vaultPill.style.background = 'rgba(99, 102, 241, 0.15)';
    vaultPill.style.borderColor = 'rgba(99, 102, 241, 0.3)';
    vaultPill.style.color = '#818cf8';
  } else {
    vaultPill.innerHTML = `<img src="${community.logo}" alt="${safeCommunityName}" class="vault-logo" /><span>No ${safeTokenSymbol} vault for ${safeCommunityName} - using backup wallet</span>`;
    vaultPill.style.background = 'rgba(239, 68, 68, 0.15)';
    vaultPill.style.borderColor = 'rgba(239, 68, 68, 0.3)';
    vaultPill.style.color = '#ef4444';
  }
}

// ------------------------------------------------------------
// Arrow overlay click handler (for up/down controls)
// ------------------------------------------------------------
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.arrow-overlay');
  if (!btn) return;

  const id = btn.getAttribute('data-target');
  const dir = btn.getAttribute('data-step');
  const input = document.getElementById(id);
  if (!input || input.disabled) return;

  if (dir === 'up') input.stepUp();
  else input.stepDown();

  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// --- Simple UI toggles (exposed globally for onclick handlers) ---
window.toggleFeature = function(id) {
  const el = document.getElementById(id);
  if (!el) return;
  el.classList.toggle('active');

  const enabled = el.classList.contains('active');

  // Enable/disable all controls inside the details area
  const detailControls = el.querySelectorAll('.asw-feature-details input, .asw-feature-details select, .asw-feature-details button, .asw-feature-details textarea');
  detailControls.forEach(ctrl => {
    // Preserve controls that should remain disabled (e.g., per-pair min/max when Random unchecked)
    if (ctrl.dataset.keepDisabled === '1') return;
    ctrl.disabled = !enabled;
  });

  // If turning off Random Pairs, also reset pair-random min/max states
  if (id === 'randomPairsToggle' && !enabled) {
    ['1','2','3'].forEach(n => {
      const cb = document.getElementById(`pair${n}Random`);
      const minI = document.getElementById(`pair${n}Min`);
      const maxI = document.getElementById(`pair${n}Max`);
      if (cb) cb.checked = false;
      if (minI) minI.disabled = true;
      if (maxI) maxI.disabled = true;
    });
  }
};

  // Pair "Random" checkboxes (within Random Swap Pairs)
  function wirePairRandom(n) {
    const cb = document.getElementById(`pair${n}Random`);
    const minI = document.getElementById(`pair${n}Min`);
    const maxI = document.getElementById(`pair${n}Max`);
    if (!cb || !minI || !maxI) return;

    // Mark min/max as keep-disabled unless checkbox is on (so parent toggle can enable but still respect checkbox)
    minI.dataset.keepDisabled = '1';
    maxI.dataset.keepDisabled = '1';

    cb.addEventListener('change', () => {
      const parentOn = document.getElementById('randomPairsToggle')?.classList.contains('active');
      const on = parentOn && cb.checked;
      minI.disabled = !on;
      maxI.disabled = !on;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Default: all three feature toggles OFF, with controls disabled
    ['randomWaitToggle','randomAmountToggle','randomPairsToggle'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      el.classList.remove('active');
      const ctrls = el.querySelectorAll('.asw-feature-details input, .asw-feature-details select, .asw-feature-details button, .asw-feature-details textarea');
      ctrls.forEach(c => c.disabled = true);
    });

    [1,2,3].forEach(wirePairRandom);
  });

// ------------------------------------------------------------
// Buffer polyfill (only if missing)
// ------------------------------------------------------------
if (typeof Buffer === 'undefined') {
    class BufferPolyfill extends Uint8Array {
      constructor(arg, encodingOrOffset, length) {
        if (typeof arg === 'number') {
          super(arg);
        } else if (typeof arg === 'string') {
          const buf = BufferPolyfill.from(arg, encodingOrOffset);
          super(buf);
        } else {
          super(arg, encodingOrOffset, length);
        }
      }

      static from(data, encoding) {
        if (encoding === 'base64') {
          const binaryString = atob(data);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const buf = new BufferPolyfill(bytes.length);
          buf.set(bytes);
          return buf;
        }
        if (encoding === 'hex') {
          const bytes = new Uint8Array(data.length / 2);
          for (let i = 0; i < data.length; i += 2) {
            bytes[i / 2] = parseInt(data.substr(i, 2), 16);
          }
          const buf = new BufferPolyfill(bytes.length);
          buf.set(bytes);
          return buf;
        }
        if (typeof data === 'string') {
          const encoder = new TextEncoder();
          const bytes = encoder.encode(data);
          const buf = new BufferPolyfill(bytes.length);
          buf.set(bytes);
          return buf;
        }
        if (Array.isArray(data) || data instanceof Uint8Array) {
          const buf = new BufferPolyfill(data.length);
          buf.set(data);
          return buf;
        }
        return new BufferPolyfill(0);
      }

      static alloc(size, fill) {
        const buf = new BufferPolyfill(size);
        if (fill !== undefined) {
          buf.fill(fill);
        }
        return buf;
      }

      static isBuffer(obj) {
        return obj instanceof BufferPolyfill || obj instanceof Uint8Array;
      }

      toString(encoding) {
        if (encoding === 'hex') {
          return Array.from(this)
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
        }
        if (encoding === 'base64') {
          return btoa(String.fromCharCode.apply(null, this));
        }
        const decoder = new TextDecoder();
        return decoder.decode(this);
      }

      readBigUInt64LE(offset = 0) {
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) {
          throw new Error('Out of bounds');
        }
        const lo = first +
          this[offset + 1] * 2 ** 8 +
          this[offset + 2] * 2 ** 16 +
          this[offset + 3] * 2 ** 24;
        const hi = this[offset + 4] +
          this[offset + 5] * 2 ** 8 +
          this[offset + 6] * 2 ** 16 +
          last * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << 32n);
      }

      readUInt32LE(offset = 0) {
        return (
          this[offset] |
          (this[offset + 1] << 8) |
          (this[offset + 2] << 16) |
          (this[offset + 3] << 24)
        ) >>> 0;
      }

      readUInt8(offset = 0) {
        return this[offset];
      }

      slice(start, end) {
        const slice = super.slice(start, end);
        const buf = new BufferPolyfill(slice.length);
        buf.set(slice);
        return buf;
      }
    }

    window.Buffer = BufferPolyfill;
  }

// ------------------------------------------------------------
// Auto Swap orchestration (was /autoswap.js)
// ------------------------------------------------------------
// autoswap.js - Auto Swap orchestration for AquaVaults
// Handles regular auto swap OR delegates to flip-flop engine

// NOTE: log() function is already defined at the top of this file

// ============================================================
// STATE
// ============================================================

let autoSwapGeneration = 0;  // Incremented on every Start and Stop — each run captures its value to detect staleness
let countdownInterval = null;
let currentSwapIndex = 0;
let totalSwapsCompleted = 0;
let totalSwapsFailed = 0;

// ============================================================
// MINT TO SYMBOL MAPPING
// ============================================================
// Note: MINT_TO_SYMBOL is already defined globally in swapper.js
// We use the global version to avoid redeclaration errors

// ============================================================
// COMPETING MODE LOGIC
// ============================================================

function setupCompetingModes() {
  const randomWaitToggle = document.getElementById('randomWaitToggle');
  const waitTimeInput = document.getElementById('waitTime');
  
  // When Random Wait Time or Random Pairs toggles
  const originalToggleFeature = window.toggleFeature;
  window.toggleFeature = function(id) {
    originalToggleFeature(id);
    
    if (id === 'randomWaitToggle') {
      const isRandomWaitActive = randomWaitToggle.classList.contains('active');
      
      // Disable/enable Wait After Swap input
      if (waitTimeInput) {
        waitTimeInput.disabled = isRandomWaitActive;
        waitTimeInput.style.opacity = isRandomWaitActive ? '0.5' : '1';
        
        // Also disable the arrow buttons
        const waitTimeArrows = waitTimeInput.closest('.input-wrapper')?.querySelectorAll('.arrow-overlay');
        if (waitTimeArrows) {
          waitTimeArrows.forEach(btn => {
            btn.disabled = isRandomWaitActive;
            btn.style.opacity = isRandomWaitActive ? '0.5' : '1';
            btn.style.cursor = isRandomWaitActive ? 'not-allowed' : 'pointer';
          });
        }
      }
    }
  };
}

// ============================================================
// CONFIGURATION BUILDER
// ============================================================

function buildAutoSwapConfig() {
  // Handle priority fee - check if custom
  const prioritySelect = document.getElementById('prioritySelect');
  const customPriorityInput = document.getElementById('customPriorityInput');
  let priorityFeeLamports = 0;
  
  if (prioritySelect && prioritySelect.value === 'custom') {
    priorityFeeLamports = Math.round(parseFloat(customPriorityInput.value) * 1e9) || 0;
  } else if (prioritySelect) {
    priorityFeeLamports = parseInt(prioritySelect.value) || 0;
  }
  
  const config = {
    totalSwaps: parseInt(document.getElementById('swapCount').value) || 10,
    waitTime: parseInt(document.getElementById('waitTime').value) || 5,
    slippageBps: Math.round(parseFloat(document.getElementById('slippageInput').value) * 100) || 100,
    platformFeeBps: Math.round(parseFloat(document.getElementById('feeInput').value) * 100) || 100,
    priorityFeeLamports: priorityFeeLamports,
    
    // Feature toggles
    useFlipFlop: document.getElementById('flipFlopToggle')?.checked || false,
    useRandomWait: document.getElementById('randomWaitToggle').classList.contains('active'),
    useRandomAmount: document.getElementById('randomAmountToggle').classList.contains('active'),
    useRandomPairs: document.getElementById('randomPairsToggle').classList.contains('active'),
    
    // Random wait settings
    minWaitTime: parseInt(document.getElementById('minWaitTime').value) || 3,
    maxWaitTime: parseInt(document.getElementById('maxWaitTime').value) || 10,
    
    // Random amount settings (global - controls Pair 1)
    minRandomAmount: parseFloat(document.getElementById('minRandomAmount').value) || 0.05,
    maxRandomAmount: parseFloat(document.getElementById('maxRandomAmount').value) || 0.25,
    
    // Pairs configuration
    pairs: getPairsConfiguration()
  };
  
  return config;
}

function getPairsConfiguration() {
  const pairs = [];
  
  // Pair 1
  const pair1From = document.getElementById('pair1From').value;
  const pair1To = document.getElementById('pair1To').value;
  if (pair1From && pair1To && pair1From !== pair1To) {
    pairs.push({
      index: 0,
      from: pair1From,
      to: pair1To,
      amount: parseFloat(document.getElementById('pair1Amount').value),
      useRandom: false, // Pair 1 uses global random amount toggle
      minAmount: 0,
      maxAmount: 0
    });
  }
  
  // Pair 2
  const pair2From = document.getElementById('pair2From').value;
  const pair2To = document.getElementById('pair2To').value;
  if (pair2From && pair2To && pair2From !== pair2To) {
    const pair2Random = document.getElementById('pair2Random').checked;
    pairs.push({
      index: 1,
      from: pair2From,
      to: pair2To,
      amount: parseFloat(document.getElementById('pair2Amount').value),
      useRandom: pair2Random,
      minAmount: parseFloat(document.getElementById('pair2Min').value) || 0,
      maxAmount: parseFloat(document.getElementById('pair2Max').value) || 0
    });
  }
  
  // Pair 3
  const pair3From = document.getElementById('pair3From').value;
  const pair3To = document.getElementById('pair3To').value;
  if (pair3From && pair3To && pair3From !== pair3To) {
    const pair3Random = document.getElementById('pair3Random').checked;
    pairs.push({
      index: 2,
      from: pair3From,
      to: pair3To,
      amount: parseFloat(document.getElementById('pair3Amount').value),
      useRandom: pair3Random,
      minAmount: parseFloat(document.getElementById('pair3Min').value) || 0,
      maxAmount: parseFloat(document.getElementById('pair3Max').value) || 0
    });
  }
  
  return pairs;
}

// ============================================================
// VALIDATION
// ============================================================

function validateConfig(config) {
  // Validate wallet connection
  if (!window.AquaVaultsSwapper || !window.AquaVaultsSwapper.isConnected()) {
    alert('Please connect your wallet first (switch to Swap tab)');
    return false;
  }
  
  // Validate pairs
  if (config.pairs.length === 0) {
    alert('Please configure at least one swap pair');
    return false;
  }
  
  // Validate random amount settings (global)
  if (config.useRandomAmount) {
    if (isNaN(config.minRandomAmount) || isNaN(config.maxRandomAmount) || 
        config.minRandomAmount <= 0 || config.maxRandomAmount <= 0) {
      alert('Please enter valid min and max amounts for Random Amount');
      return false;
    }
    
    if (config.minRandomAmount >= config.maxRandomAmount) {
      alert('Min amount must be less than max amount');
      return false;
    }
  }
  
  // Validate random wait settings
  if (config.useRandomWait) {
    if (isNaN(config.minWaitTime) || isNaN(config.maxWaitTime) || 
        config.minWaitTime < 0 || config.maxWaitTime < 0) {
      alert('Please enter valid min and max wait times');
      return false;
    }
    
    if (config.minWaitTime >= config.maxWaitTime) {
      alert('Min wait time must be less than max wait time');
      return false;
    }
  }
  
  // Validate per-pair random amounts
  for (const pair of config.pairs) {
    if (pair.useRandom) {
      if (isNaN(pair.minAmount) || isNaN(pair.maxAmount) || 
          pair.minAmount <= 0 || pair.maxAmount <= 0) {
        alert(`Pair ${pair.index + 1}: Please enter valid min and max amounts`);
        return false;
      }
      
      if (pair.minAmount >= pair.maxAmount) {
        alert(`Pair ${pair.index + 1}: Min amount must be less than max amount`);
        return false;
      }
    }
  }
  
  return true;
}

// ============================================================
// REGULAR AUTO SWAP (WITHOUT FLIP-FLOP)
// ============================================================

async function executeRegularAutoSwap(config, myGeneration) {
  for (let i = 1; i <= config.totalSwaps; i++) {
    if (myGeneration !== autoSwapGeneration) break;
    
    currentSwapIndex = i;
    
    // Determine swap parameters
    let fromMint, toMint, amount;
    
    if (config.useRandomPairs) {
      // Random pairs mode
      const selectedPair = config.pairs[Math.floor(Math.random() * config.pairs.length)];
      fromMint = selectedPair.from;
      toMint = selectedPair.to;
      
      // Determine amount
      if (selectedPair.index === 0 && config.useRandomAmount) {
        // Pair 1 uses global random amount
        amount = (Math.random() * (config.maxRandomAmount - config.minRandomAmount) + config.minRandomAmount).toFixed(4);
      } else if (selectedPair.useRandom) {
        // Pair has its own random amount
        amount = (Math.random() * (selectedPair.maxAmount - selectedPair.minAmount) + selectedPair.minAmount).toFixed(4);
      } else {
        // Fixed amount
        amount = selectedPair.amount;
      }
      
      if (window.debugLog) window.debugLog(`Random pair ${i}/${config.totalSwaps}: Pair ${selectedPair.index + 1}, Amount: ${amount}`);
    } else {
      // Use Pair 1 (default)
      const pair = config.pairs[0];
      fromMint = pair.from;
      toMint = pair.to;
      
      if (config.useRandomAmount) {
        amount = (Math.random() * (config.maxRandomAmount - config.minRandomAmount) + config.minRandomAmount).toFixed(4);
        if (window.debugLog) window.debugLog(`Random amount for swap ${i}/${config.totalSwaps}: ${amount}`);
      } else {
        amount = pair.amount;
      }
    }
    
    const fromSymbol = (window.TokenRegistry && window.TokenRegistry.getSymbol)
      ? window.TokenRegistry.getSymbol(fromMint)
      : (MINT_TO_SYMBOL[fromMint] || fromMint.slice(0, 4) + '...');

    const toSymbol = (window.TokenRegistry && window.TokenRegistry.getSymbol)
      ? window.TokenRegistry.getSymbol(toMint)
      : (MINT_TO_SYMBOL[toMint] || toMint.slice(0, 4) + '...');
    
    // Update progress
    updateProgress(`Swap ${i} of ${config.totalSwaps}`, `${fromSymbol} → → ${toSymbol}: ${amount}`);
    
    // Execute swap
    try {
      if (window.debugLog) window.debugLog(`Executing swap ${i}/${config.totalSwaps}: ${amount} ${fromSymbol} → → ${toSymbol}`);
      
      const result = await window.AquaVaultsSwapper.executeSwap(
        fromMint,
        toMint,
        parseFloat(amount),
        config.slippageBps,
        config.platformFeeBps,
        config.priorityFeeLamports
      );
      
      totalSwapsCompleted++;
      if (window.debugLog) window.debugLog(`Auto swap ${i}/${config.totalSwaps} SUCCESS`, 'success');
      
    } catch (err) {
      totalSwapsFailed++;
      log(`Auto swap ${i}/${config.totalSwaps} FAILED: ${err.message}`, 'error');
    }
    
    // Wait before next swap (if not last and still active)
    if (i < config.totalSwaps && myGeneration === autoSwapGeneration) {
      await waitBetweenSwaps(config, i, myGeneration);
    }
  }
}

// ============================================================
// WAIT LOGIC
// ============================================================

async function waitBetweenSwaps(config, swapIndex, myGeneration) {
  let actualWaitTime = config.waitTime;
  
  if (config.useRandomWait) {
    actualWaitTime = Math.floor(Math.random() * (config.maxWaitTime - config.minWaitTime + 1)) + config.minWaitTime;
    if (window.debugLog) window.debugLog(`Random wait time: ${actualWaitTime}s`);
  }
  
  if (actualWaitTime > 0) {
    await countdown(actualWaitTime, swapIndex, myGeneration);
  }
}

async function countdown(seconds, swapIndex, myGeneration) {
  return new Promise(resolve => {
    let remaining = seconds;
    const totalSwaps = document.getElementById('swapCount').value;
    updateProgress(`Swap ${swapIndex} of ${totalSwaps} complete`, `Next swap in ${remaining}s...`);
    
    countdownInterval = setInterval(() => {
      remaining--;
      if (remaining <= 0 || myGeneration !== autoSwapGeneration) {
        clearInterval(countdownInterval);
        countdownInterval = null;
        // Only update progress if we're still the active run
        if (myGeneration === autoSwapGeneration) {
          updateProgress(`Ready for swap ${swapIndex + 1}`, '');
        }
        resolve();
      } else {
        updateProgress(`Swap ${swapIndex} complete`, `Next swap in ${remaining}s...`);
      }
    }, 1000);
  });
}

// ============================================================
// MAIN EXECUTION
// ============================================================
// ============================================================
// CONFIGURATION PREVIEW
// ============================================================

function logConfigurationPreview(config) {
  log('=== AUTO SWAP Settings ===', 'info');
  // Affiliate
  const community = window.CommunityRegistry ? window.CommunityRegistry.get(selectedCommunityId) : null;
  log('Community: ' + (community ? community.name : 'None'), 'info');
  log('Platform Fee: ' + (config.platformFeeBps / 100).toFixed(2) + '%', 'info');
  log('Slippage: ' + (config.slippageBps / 100).toFixed(2) + '%', 'info');
  log('Priority Fee: ' + (config.priorityFeeLamports === 0 ? 'Auto' : config.priorityFeeLamports + ' lamports'), 'info');
// Pair configurations
  if (config.useRandomPairs) {
    log('Random Pairs: ' + config.pairs.length + ' pairs', 'info');
    config.pairs.forEach((pair, index) => {
      const fromSymbol = (window.TokenRegistry && window.TokenRegistry.getSymbol)
        ? window.TokenRegistry.getSymbol(pair.from)
        : (MINT_TO_SYMBOL[pair.from] || pair.from.slice(0, 4) + '...');

      const toSymbol = (window.TokenRegistry && window.TokenRegistry.getSymbol)
        ? window.TokenRegistry.getSymbol(pair.to)
        : (MINT_TO_SYMBOL[pair.to] || pair.to.slice(0, 4) + '...');

      let amountInfo = '';
      if (pair.index === 0 && config.useRandomAmount) {
        amountInfo = ' (Random: ' + config.minRandomAmount + ' - ' + config.maxRandomAmount + ')';
      } else if (pair.useRandom) {
        amountInfo = ' (Random: ' + pair.minAmount + ' - ' + pair.maxAmount + ')';
      } else {
        amountInfo = ' (Fixed: ' + pair.amount + ')';
      }
      log('Pair ' + (pair.index + 1) + ': ' + fromSymbol + ' → → ' + toSymbol + amountInfo, 'info');
    });
  } else {
    const pair = config.pairs[0];
    if (pair) {
      const fromSymbol = (window.TokenRegistry && window.TokenRegistry.getSymbol)
        ? window.TokenRegistry.getSymbol(pair.from)
        : (MINT_TO_SYMBOL[pair.from] || pair.from.slice(0, 4) + '...');

      const toSymbol = (window.TokenRegistry && window.TokenRegistry.getSymbol)
        ? window.TokenRegistry.getSymbol(pair.to)
        : (MINT_TO_SYMBOL[pair.to] || pair.to.slice(0, 4) + '...');

      if (config.useRandomAmount) {
        log('Pair: ' + fromSymbol + ' → → ' + toSymbol + ' (Random: ' + config.minRandomAmount + ' - ' + config.maxRandomAmount + ')', 'info');
      } else {
        log('Pair: ' + fromSymbol + ' → → ' + toSymbol + ' (Fixed: ' + pair.amount + ')', 'info');
      }
    }
  }
  log('Total Swaps: ' + config.totalSwaps, 'info');
  // Wait time settings - only log if random wait is ON
  if (config.useRandomWait) {
    log('Random Wait: ' + config.minWaitTime + 's - ' + config.maxWaitTime + 's', 'info');
  } else {
    log('Fixed Wait: ' + config.waitTime + 's', 'info');
  }
    
  // Flip-Flop mode - only log if ACTIVE
  if (config.useFlipFlop) {
    log('Flip-Flop Mode: ACTIVE', 'info');
  }

  log('==========================', 'info');
}

async function executeAutoSwap() {
  // Claim this run's generation — any prior run becomes stale immediately
  autoSwapGeneration++;
  const myGeneration = autoSwapGeneration;

  // Lock buttons before any work — prevents re-entry from rapid clicks
  document.getElementById('autoStart').disabled = true;
  document.getElementById('autoStart').style.display = 'none';
  document.getElementById('autoStop').disabled = false;
  document.getElementById('autoStop').style.display = 'block';

  // Build configuration
  const config = buildAutoSwapConfig();
  
  // Validate — restore buttons on failure, but only if we're still the active run
  if (!validateConfig(config)) {
    if (myGeneration === autoSwapGeneration) {
      document.getElementById('autoStart').disabled = false;
      document.getElementById('autoStart').style.display = 'block';
      document.getElementById('autoStop').disabled = true;
      document.getElementById('autoStop').style.display = 'none';
    }
    return;
  }
  
  // Log configuration
  logConfigurationPreview(config);
  
  // Suppress per-swap settings log in executeSwap for the duration of this cycle — already logged above.
  window._autoswapActive = true;
  
  // Reset counters
  totalSwapsCompleted = 0;
  totalSwapsFailed = 0;
  currentSwapIndex = 0;
  
  if (window.debugLog) window.debugLog(`Starting ${config.totalSwaps} swap${config.totalSwaps > 1 ? 's' : ''}${config.useFlipFlop ? ' (Flip-Flop)' : ''}`);
  
  try {
    if (config.useFlipFlop && window.FlipFlopEngine) {
      
      const callbacks = {
        onProgress: updateProgress,
        onSuccess: (index) => { totalSwapsCompleted++; updateAllBalances(); },
        onFailure: (index, err) => { totalSwapsFailed++; },
        onWait: async (cfg, idx) => { await waitBetweenSwaps(cfg, idx, myGeneration); }
      };
      
      await window.FlipFlopEngine.execute(config, callbacks);
      
    } else {
      // Regular auto swap
      await executeRegularAutoSwap(config, myGeneration);
    }
    
    // Only log completion if we're still the active run
    if (myGeneration !== autoSwapGeneration) return;

    // Complete
    const summary = `Finished: ${totalSwapsCompleted} succeeded, ${totalSwapsFailed} failed`;
    if (window.debugLog) window.debugLog(summary);
    updateProgress(summary, '');
    
    // Show warning if failures
    if (totalSwapsFailed > 0) {
      updateProgress(
        `⚠️ ${totalSwapsFailed} of ${config.totalSwaps} swaps failed`,
        'Check console for details'
      );
    }
    
  } catch (err) {
    // Only report if we're still the active run
    if (myGeneration !== autoSwapGeneration) return;
    log('❌ Auto swap error:', err, 'error');
    updateProgress(`❌ Error: ${err.message}`, '');
  } finally {
    window._autoswapActive = false;
    stopAutoSwap();
    // Re-enable Start here unconditionally — this is the only place that does so.
    // Guarantees no new run can launch until this executeAutoSwap has fully exited,
    // even if Stop was clicked while an executeSwap was in flight.
    document.getElementById('autoStart').disabled = false;
  }
}

// ============================================================
// HELPER FUNCTIONS
// ============================================================

function updateProgress(status, detail) {
  const progressEl = document.getElementById('autoProgress');
  if (progressEl) {
    progressEl.textContent = status;
  }
  
  const countdownEl = document.getElementById('autoCountdown');
  if (countdownEl) {
    countdownEl.textContent = detail || '';
  }
}

function stopAutoSwap() {
  // Invalidate any currently running cycle — it will exit silently on its next check
  autoSwapGeneration++;
  
  // Cancel flip-flop if running
  if (window.FlipFlopEngine) {
    window.FlipFlopEngine.cancel();
  }
  
  if (countdownInterval) {
    clearInterval(countdownInterval);
    countdownInterval = null;
  }
  
  document.getElementById('autoStart').style.display = 'block';
  document.getElementById('autoStop').disabled = true;
  document.getElementById('autoStop').style.display = 'none';
  
  const countdownEl = document.getElementById('autoCountdown');
  if (countdownEl) {
    countdownEl.textContent = ' ';
  }
}

// ============================================================
// INITIALIZATION
// ============================================================

function initializeAutoSwap() {
  // Initialize community dropdown
  initCommunityDropdown();
  
  // Setup competing modes
  setupCompetingModes();
  
  // Enable start button when wallet is connected
  if (window.AquaVaultsSwapper && window.AquaVaultsSwapper.isConnected()) {
    document.getElementById('autoStart').disabled = false;
  }
  
  // Set up pair random checkboxes
  [2, 3].forEach(n => {
    const checkbox = document.getElementById(`pair${n}Random`);
    const minInput = document.getElementById(`pair${n}Min`);
    const maxInput = document.getElementById(`pair${n}Max`);
    const amountInput = document.getElementById(`pair${n}Amount`);
    
    if (checkbox && minInput && maxInput && amountInput) {
      checkbox.addEventListener('change', () => {
        const isChecked = checkbox.checked;
        minInput.disabled = !isChecked;
        maxInput.disabled = !isChecked;
        amountInput.disabled = isChecked;
        amountInput.style.opacity = isChecked ? '0.5' : '1';
      });
    }
  });
  
  // Update vault display when pair changes
  const pair1From = document.getElementById('pair1From');
  if (pair1From) {
    pair1From.addEventListener('change', () => {
      updateVaultDisplay();
    });
  }
}

// ============================================================
// EXPORTS
// ============================================================

window.AquaVaultsAutoSwap = {
  start: executeAutoSwap,
  stop: stopAutoSwap,
  isRunning: () => document.getElementById('autoStop').style.display === 'block',
  initialize: initializeAutoSwap
};

// ------------------------------------------------------------
// UI HANDLER FUNCTIONS (exposed globally for onclick handlers)
// ------------------------------------------------------------

// Check settings handler
window.handleCheckSettings = function() {
  
  // Build configuration
  const config = buildAutoSwapConfig();
  
  // Validate
  if (!validateConfig(config)) {
    return;
  }
  
  // Log preview
  logConfigurationPreview(config);
};

// Auto start handler
window.handleAutoStart = async function() {
  // Block re-entry — if already running, ignore the click entirely
  const startBtn = document.getElementById('autoStart');
  if (startBtn.disabled) return;
  startBtn.disabled = true;

  if (!window.AquaVaultsAutoSwap) {
    alert('Auto swap module not loaded', 'error');
    startBtn.disabled = false;
    return;
  }
  
  // Check if wallet is connected via header state
  const walletState = window.AquaVaultsHeader ? window.AquaVaultsHeader.getWalletState() : { connected: false };
  
  if (!walletState.connected) {
    alert('Please connect wallet first using the Connect Wallet button in the header.', 'warning');
    return;
  }
  
  await window.AquaVaultsAutoSwap.start();
};

// Auto stop handler
window.handleAutoStop = function() {
  if (window.AquaVaultsAutoSwap) {
    window.AquaVaultsAutoSwap.stop();
  }
};

// ============================================================
// URL PARAMETER HANDLING
// ============================================================

// Check for community parameter in URL and auto-select
function handleCommunityFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const communityId = urlParams.get('community');
  
  if (communityId && window.CommunityRegistry && window.CommunityRegistry.has(communityId)) {
    // Store the community ID temporarily
    window._pendingCommunitySelection = communityId;
    
    // Log the pending selection
    if (window.debugLog) {
      window.debugLog(`Community from URL will be selected: ${communityId}`, 'info');
    }
    
    // Clean URL (remove query parameter)
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}

// ------------------------------------------------------------
// Page init (was inline in HTML)
// ------------------------------------------------------------
// Initialize when page loads
window.addEventListener('DOMContentLoaded', async () => {
  
  // Handle community from URL parameter
  handleCommunityFromURL();
  
  // Populate custom tokens in all dropdowns (silent)
  populateCustomTokensInAllDropdowns();
  
  // Load fee setting
  const savedFee = localStorage.getItem('platformFeeBps');
  if (savedFee !== null) {
    const feeInput = document.getElementById('feeInput');
    if (feeInput) {
      // Convert bps to percent (100 bps = 1%)
      const percent = parseFloat(savedFee) / 100;
      feeInput.value = percent.toFixed(1);
      window.updateFeeDisplay();
    }
  }
  
  // Load slippage setting
  const savedSlippage = localStorage.getItem('slippageBps');
  if (savedSlippage !== null) {
    const slippageInput = document.getElementById('slippageInput');
    if (slippageInput) {
      // Convert bps to percent (100 bps = 1%)
      const percent = parseFloat(savedSlippage) / 100;
      slippageInput.value = percent.toFixed(1);
      window.updateSlippageDisplay();
    }
  }
  
  // Load priority setting
  const savedPriority = localStorage.getItem('priorityFeeLamports');
  if (savedPriority !== null) {
    const prioritySelect = document.getElementById('prioritySelect');
    const customInput = document.getElementById('customPriorityInput');
    if (prioritySelect) {
      const lamports = parseInt(savedPriority);
      
      // Check if it matches a preset
      if (lamports === 0) {
        prioritySelect.value = '0';
      } else if (lamports === 10000) {
        prioritySelect.value = '10000';
      } else if (lamports === 100000) {
        prioritySelect.value = '100000';
      } else if (lamports === 500000) {
        prioritySelect.value = '500000';
      } else {
        // Custom value
        prioritySelect.value = 'custom';
        if (customInput) {
          const sol = lamports / 1000000000;
          customInput.value = sol.toFixed(5);
        }
      }
      
      window.updatePriorityDisplay();
    }
  }
  
  // Load expanded state
  const savedExpanded = localStorage.getItem('swapSettingsExpanded');
  if (savedExpanded === 'true') {
    const container = document.getElementById('constraintsContainer');
    if (container) {
      container.classList.add('expanded');
    }
  }

  // ============================================================
  // INITIALIZE COMMUNITY SELECTOR
  // ============================================================
  
  // Re-initialize community dropdown when page is restored from bfcache
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      initCommunityDropdown();
      if (typeof updateVaultDisplay === 'function') updateVaultDisplay();
    }
  });

  // Initialize community dropdown after DOM is ready
  setTimeout(() => {
    initCommunityDropdown();
    
    // After dropdown is initialized, check if we need to select a community from URL
    if (window._pendingCommunitySelection) {
      const communityId = window._pendingCommunitySelection;
      delete window._pendingCommunitySelection;
      
      // Now actually select the community
      if (typeof selectCommunity === 'function') {
        selectCommunity(communityId);
        if (window.debugLog) {
          window.debugLog(`Auto-selected community: ${communityId}`, 'silent-success');
        }
      }
    }
  }, 100);

  // Add event listener to update vault when token changes
  const pair1From = document.getElementById('pair1From');
  if (pair1From) {
    pair1From.addEventListener('change', () => {
      updateVaultDisplay();
    });
  }

  // ============================================================
  // INITIALIZE RPC AND WALLET
  // ============================================================
  
  // Check if swapper is loaded
  if (!window.AquaVaultsSwapper) {
    log('❌ Swapper module not loaded');
    alert('Error: Swapper module not loaded. Please refresh the page.');
    return;
  }
  
  // Initialize RPC connection
  const connected = await window.AquaVaultsSwapper.initializeConnection();
  
  if (!connected) {
    log('❌ RPC connection failed');
    alert('Connection failed. Please check your network and refresh the page.');
    return;
  }
  
  
// ============================================================
  // LISTEN FOR WALLET STATE CHANGES FROM HEADER
  // ============================================================
  
  window.addEventListener('walletStateChanged', function(event) {
    const state = event.detail;
    const autoStartBtn = document.getElementById('autoStart');
    
    if (state.connected) {
      if (autoStartBtn) {
        autoStartBtn.disabled = false;
      }
      // Update all balance displays
      updateAllBalances();
    } else {
      if (autoStartBtn) {
        autoStartBtn.disabled = true;
      }
      // Clear all balance displays
      updateAllBalances();
    }
  });
  
  // Check initial wallet state from header
  if (window.AquaVaultsHeader) {
    const initialState = window.AquaVaultsHeader.getWalletState();
    if (initialState.connected) {
      const autoStartBtn = document.getElementById('autoStart');
      if (autoStartBtn) {
        autoStartBtn.disabled = false;
      }
      // Load initial balances
      setTimeout(() => updateAllBalances(), 200);
    }
  }
  
  // ============================================================
  // INITIALIZE AUTO SWAP MODULE
  // ============================================================
  
  if (window.AquaVaultsAutoSwap) {
    window.AquaVaultsAutoSwap.initialize();
  } else {
    log('❌ Auto Swap module not found', 'error');
    return;
  }
  
  // Show initialization summary after a brief delay to check wallet state
  setTimeout(() => {
    if (window.AquaVaultsHeader) {
      const state = window.AquaVaultsHeader.getWalletState();
      if (state.connected) {
        log('Wallet: ' + state.address.slice(0, 4) + '...' + state.address.slice(-4), 'silent-success');
        log('AquaVaults Auto Swapper Ready', 'silent-success');
      } else {
        log('Wallet: ---');
        log('Please Connect Wallet');
      }
    }
  }, 1500);
});

// ============================================================
// TAB SWITCHING
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
  const tabSwap = document.getElementById('tabSwap');
  const tabAuto = document.getElementById('tabAuto');
  
  if (tabSwap) {
    tabSwap.addEventListener('click', () => {
      // Navigate to swap-card.html
      window.location.href = '/swap';
    });
  }
  
  if (tabAuto) {
    tabAuto.addEventListener('click', () => {
      // Stay on current page (autoswap-card.html)
      // Already here, just ensure active state
      tabAuto.classList.add('active');
      if (tabSwap) tabSwap.classList.remove('active');
    });
  }
});

// Failsafe: poll until the community display is populated.
// Covers all edge cases — defer timing, bfcache, slow registry load.
(function ensureCommunityInit() {
  let attempts = 0;
  const poll = setInterval(() => {
    attempts++;
    const el = document.getElementById('communitySelected');
    const hasContent = el && el.querySelector('.community-selected-content');
    if (hasContent || attempts > 25) {
      clearInterval(poll);
      return;
    }
    if (window.CommunityRegistry && el) {
      if (!localStorage.getItem('selectedCommunity')) {
        localStorage.setItem('selectedCommunity', 'aquavaults');
      }
      initCommunityDropdown();
    }
  }, 200);
})();
// defer scripts, so CommunityRegistry and DOM elements both exist now.
if (window.CommunityRegistry && document.getElementById('communitySelected')) {
  if (!selectedCommunityId) {
    selectedCommunityId = localStorage.getItem('selectedCommunity');
    if (!selectedCommunityId) {
      selectedCommunityId = 'aquavaults';
      localStorage.setItem('selectedCommunity', 'aquavaults');
    }
  }
  const _el = document.getElementById('communitySelected');
  if (_el && _el.querySelector('.select-prompt')) {
    initCommunityDropdown();
  }
}
